/* 三國逗陣打 · 遊戲邏輯（純模擬，不碰 DOM）
 * 之後連線版會把這一層搬到權威伺服器；畫面層只讀取 world 狀態與事件。
 *
 * 地面座標：前後縱深（y）壓縮為 K = 0.7。距離、範圍、方向一律用「地面度量」
 * gd = hypot(dx, dy / K)，所以範圍在畫面上是橫向較寬的橢圓，瞄準點永遠落在游標上。
 *
 * 操作指令（u.input）：
 *   mx, my      方向移動（地面度量的單位向量，鍵盤／WASD）
 *   moveTo      [x, y] 走到某點（右鍵、AI）
 *   target      普攻目標（右鍵點敵人、AI、小兵）
 *   aim         [x, y] 游標位置，技能與無目標普攻朝這裡
 *   attack      立即朝 aim 普攻（WASD 左鍵、鍵盤 Z）
 *   skill       { i, x, y } 施放技能
 *   jump, defend, item, cancel（移動可取消普攻後搖）, hard（新指令可取消前搖） */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from './sg.ts';
import { at } from './hooks.ts';

// 武將檔登記的專屬招式與時間點（武將檔比 sim 早載入）
const SIG_SKILL = {};
for (const m of SG.HERO_MODS || []) Object.assign(SIG_SKILL, m.sigSkills);
const H_HERO_EARLY = at('step.hero.early'), H_ONHIT_PRE = at('onHit.pre');

const M = SG.MAP;
// 模擬用的亂數：平常就是 Math.random；World 帶 seed 時換成可重現的（錄影比對、重現問題用）
SG.rand = Math.random;
SG.seeded = function (seed) {
  let a = seed | 0;
  return function () { a = (a + 0x6d2b79f5) | 0; let t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
};
const K = 0.7;
const MOVE_ARCH = { charge: 1, dash: 1, blink: 1, slam: 1 };
const BASE_CD = { bolt: 6, multi: 7, charge: 10, blink: 12, heal: 12, shield: 14, buff: 16, trap: 12, hook: 12, spikes: 9, thunder: 10, fire: 11, spin: 10, stealth: 18, roar: 14, summon: 20, command: 20, volley: 14, crescent: 10, dash: 12, slam: 12 };
// 技能瞄準：dir＝朝方向、point＝指定地點、self＝以自己為中心；range＝最遠距離，area＝範圍半徑
const AIM = {
  bolt: { kind: 'dir', range: 520, width: 14 }, crescent: { kind: 'dir', range: 460, width: 40 }, hook: { kind: 'dir', range: 330, width: 18 },
  charge: { kind: 'dir', range: 240, width: 40 }, dash: { kind: 'dir', range: 170, width: 60 }, spikes: { kind: 'dir', range: 250, width: 32 },
  fire: { kind: 'dir', range: 290, width: 56 }, roar: { kind: 'cone', range: 300, cos: 0.64 }, multi: { kind: 'cone', range: 120, cos: 0.55 },
  thunder: { kind: 'point', range: 520, area: 92 }, volley: { kind: 'point', range: 520, area: 84 }, trap: { kind: 'point', range: 380, area: 70 },
  slam: { kind: 'point', range: 300, area: 145 }, blink: { kind: 'point', range: 320, area: 0 }, summon: { kind: 'point', range: 220, area: 60 },
  spin: { kind: 'self', area: 125 }, heal: { kind: 'self', area: 330 }, command: { kind: 'self', area: 540 }, shield: { kind: 'self', area: 300 },
  buff: { kind: 'self', area: 0 }, stealth: { kind: 'self', area: 0 }, passive: { kind: 'self', area: 0 },
};
// 技能收招可被下一個技能／跳躍／抓人取消的時間點（動作長度比例，都在最後一段效果之後）
const REL = { multi: 0.62, spin: 0.68, dash: 0.62, charge: 0.64, blink: 0.42, slam: 0.6, crescent: 0.46, bolt: 0.72, hook: 0.46, fire: 0.8, spikes: 0.8,
  volley: 0.56, thunder: 0.56, roar: 0.5, heal: 0.4, shield: 0.26, buff: 0.34, command: 0.34, summon: 0.44, trap: 0.44, stealth: 0.32 };
SG.STACK = 5; // 消耗品一格最多疊幾個
SG.itemQty = (u, i) => (u.items && u.items[i] ? Math.max(1, (u.iq && u.iq[i]) || 1) : 0); // 這一格有幾個（沒記數量的當 1 個）
SG.AIM = AIM; SG.K = K; SG.REL = REL;
// 依等級取值：陣列＝各級數值
const L = (v, lvl) => (Array.isArray(v) ? v[Math.min(v.length, Math.max(1, lvl || 1)) - 1] : v);
SG.L = L;
SG.HERO_MS = 0.8;
SG.MS_CAP = 480; // 移速上限（v0.4.2.1）：設計上最快的組合也要算得出來在這之下，這裡只防 bug
// 擊敗呂布（v0.3.8）：不再掉赤兔馬，改成全隊增益「飛將之威」：攻擊 +15%、攻速 +15%、移速 +8%、受到傷害 -10%，120 秒（陣亡期間不計，復活後只要還沒到期就繼續有）
SG.LUBU_BUFF = { name: '飛將之威', t: 120, atkP: 0.15, as: 15, ms: 0.08, taken: -0.1 };
SG.DEFEND_ARMOR = [1.2, 8];
SG.DEFEND_BLOCK_MUL = 2; // 防禦擋下的量再乘上這個倍數（v0.4.2）
// 實際攻速（v0.3.8 使用者：「攻速 +100%」要真的變 2 倍）：屬性＋裝備的攻速照舊相加，技能增益（bf.as）改成乘上去；rampAs 是諸葛連弩連發加速
SG.effAsp = (u) => Math.max(40, ((u.asp || 100) + (u.rampAs || 0)) * Math.max(0.2, 1 + (u.bf ? u.bf.as : 0) / 100)); // 防禦（v0.3.8）：按住時物防 ×1.2 再 +8（只擋物理）。前期約 -27%、後期約 -21%，以百分比計所以不怕傷害膨脹
SG.CAST_FAST = 1.3; // 小技能動作播放倍速
SG.MELEE_ATK = 1.08;
// v0.3.4 技能類型：點擊技（指定單體，必中、不會被擋）／指向技（朝方向，會被擋或打偏 → 傷害、控制 +10%）／範圍技／自身
SG.SKILLSHOT_BONUS = 1.1;
SG.SKILL_TYPE_NAME = { unit: '點擊技', dir: '指向技', point: '範圍技', self: '自身' };
const CC_TIME = ['stun', 'root', 'fear', 'silence', 'knockup', 'down', 'freeze', 'taunt', 'charm', 'confuse', 'disarm'];
SG.scaleCC = (cc, k) => {
  if (!cc || k === 1) return cc;
  const o = Object.assign({}, cc);
  for (const key of CC_TIME) if (typeof o[key] === 'number') o[key] *= k;
  if (Array.isArray(o.slow)) o.slow = [o.slow[0], o.slow[1] * k]; else if (o.slow && typeof o.slow === 'object') o.slow = Object.assign({}, o.slow, { dur: o.slow.dur * k });
  return o;
};
SG.MELEE_ATK_NOTE = 1; // 近戰普攻改單體目標後的補償
SG.ORIG_MUL = 1.3; // 原創技能的傷害倍率：拉到和 3.7D 技能相近的水準
// ---------- v0.3.0 技能成長：吃智力／吃武力／吃敏捷／固定 ----------
// 有傷害的技能預設吃武將的主屬性；沒傷害（增益、召喚、位移…）是固定。技能資料可用 scale: 'str'|'agi'|'int'|'fixed' 覆寫。
// 傷害 ＝ 基礎 ＋ 係數 × 屬性（吃智力用法攻＝智＋裝備法攻）；係數：小技能 0.8、大招 1.2
SG.SCALE_COEF = [0.8, 0.8, 0.8, 1.2];
SG.SCALE_NAME = { str: '吃武力', agi: '吃敏捷', int: '吃智力', fixed: '固定' };
SG.skillBase = (sk, lvl) => (sk.x ? (L(sk.x.dmg, lvl) || L(sk.x.dps, lvl) || 0) : parseVal(sk.desc, lvl));
// 整招估計總傷害（多段、持續區域、附加持續傷害都算進去）：成長是「總傷害 ＋ 係數 × 屬性」，換成倍率套到每一段
SG.skillTotal = (sk, lvl) => {
  const X = sk.x;
  if (!X) return parseVal(sk.desc, lvl);
  let d = L(X.dmg, lvl) || 0;
  if (X.dps) d = Math.max(d, L(X.dps, lvl) * (L(X.dur, lvl) || 1));
  else if (X.n) d *= Math.min(4, L(X.n, lvl));
  else if (X.k === 'whirl') d *= 3;
  if (X.dot) d += L(X.dot.dps, lvl) * (X.dot.dur || 1);
  return d;
};
// 技能本身就以屬性計算（例如「敏捷 ×2.2」）：標成吃該屬性，但不再另外加成長
SG.selfScaled = (sk) => { const X = sk && sk.x; return X ? (X.agiMul ? 'agi' : X.strMul ? 'str' : X.intMul && !X.dmg ? 'int' : null) : null; };
SG.skillScale = (spec, i) => {
  const sk = spec.skills[i];
  if (!sk || sk.passive) return 'fixed';
  if (sk.scale) return sk.scale;
  if (SG.selfScaled(sk)) return SG.selfScaled(sk);
  return SG.skillBase(sk, 1) > 0 ? (spec.attr || (SG.ROLES[spec.statRole || spec.role] || SG.ROLES['戰士']).main) : 'fixed';
};
SG.scaleAttr = (u, cls) => (cls === 'int' ? (u.matk != null ? u.matk : u.int || 0) : cls === 'str' ? u.str || 0 : cls === 'agi' ? u.agi || 0 : 0);
// 技能傷害倍率：技能傷害% × 屬性成長（施放中的技能）
SG.spMul = (u) => (1 + ((u.sp || 0) + (u.spAura || 0)) / 100) * (u.skG || 1) * (u.qimenT > 0 ? 1 + (u.qimenAmp || 0) : 1); // 奇門遁甲：瞬移後技能 +20%
// 「能」（docs/ENERGY-SURVEY.md §6）：跟「氣」分開的資源。武將資料寫 res: 'neng' 就用能。
// 上限永遠 100、每秒回 5（本營也一樣），智力、裝備、燒氣、補氣、藥水都改變不了它。
SG.NENG = { max: 100, regen: 5 };
SG.isNeng = (u) => !!(u && u.spec && u.spec.res === 'neng');
SG.resName = (u) => (SG.isNeng(u) ? '能' : '氣');
// 不耗資源（res: 'none'，周泰）：沒有氣也沒有能，技能只看冷卻
SG.noRes = (u) => !!(u && u.spec && u.spec.res === 'none');
// 兩段式技能：第二段開著的時候，這一格是第二段那一招
SG.skillAt = (u, i) => { const r = u.rc && u.rc[i]; return (r && r.alt) || (u.spec.skills && u.spec.skills[i]); };
SG.CD_SCALE = 0.6; // 3.7D 的冷卻是以 40 分鐘一場設計的，這裡一場約 15 分鐘，統一乘上這個比例
// 技能瞄準方式：技能自帶 aim 時優先（range／area 可為各級陣列）
SG.aimOf = (sk, lvl) => {
  if (!sk.aim) return AIM[sk.arch] || AIM.buff;
  const b = sk.aim;
  return { kind: b.kind, range: L(b.range, lvl), area: L(b.area, lvl) || 0, width: b.width || 30, cos: b.cos || 0.6, line: b.line || null, face: b.face || null, off: b.off || 0 };
};
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
const sign = (v) => (v > 0 ? 1 : v < 0 ? -1 : 0);
const gd = (ax, ay, bx, by) => Math.hypot(bx - ax, (by - ay) / K);
const dirTo = (u, x, y) => { const gx = x - u.x, gy = (y - u.y) / K, d = Math.hypot(gx, gy); return d < 1e-3 ? [u.f, 0] : [gx / d, gy / d]; };
const rot = (d, a) => { const c = Math.cos(a), s = Math.sin(a); return [d[0] * c - d[1] * s, d[0] * s + d[1] * c]; };
const along = (x, y, dir, d) => [x + dir[0] * d, y + dir[1] * d * K];
SG.gd = gd; SG.dirTo = dirTo; SG.along = along;
let uid = 1;

// 從技能說明取出「傷害／生命」數值：{a/b/c/d} 後面接傷害或生命的那一組
function parseVal(desc, lvl) {
  if (!lvl) return 0;
  const re = /\{([^}]+)\}/g;
  let m;
  while ((m = re.exec(desc))) {
    const arr = m[1].split('/').map(Number);
    if (arr.some(isNaN) || Math.max.apply(null, arr) < 10) continue;
    const after = desc.substr(re.lastIndex, 8), before = desc.substr(Math.max(0, m.index - 6), 6);
    if (/^%/.test(after)) continue;
    if (/傷害|生命/.test(after) || /造成|治療|吸收|擋下/.test(before)) return arr[Math.min(arr.length, lvl) - 1];
  }
  return 0;
}
SG.parseVal = parseVal;

// ---------- 控制效果：從技能說明讀出 ----------
const CC_KEYS = [
  ['stun', /暈眩|砸暈/, 0.8], ['root', /定身|困住/, 1], ['knockup', /擊飛|挑空|挑起/, 0.8], ['knockdown', /擊倒/, 1], ['freeze', /凍結/, 0.8],
  ['silence', /沉默|不能用技能/, 1.2], ['fear', /恐懼/, 1.5], ['taunt', /嘲諷|逼他們攻擊自己/, 1], ['disarm', /不能攻擊/, 1.2],
  ['charm', /魅惑|走過來/, 1], ['confuse', /隨機|迷失|互相攻擊|攻擊自己人|攻擊其友軍|攻擊自己的友軍/, 1.5],
];
const HARD_CC = ['stun', 'root', 'knockup', 'knockdown', 'freeze', 'fear', 'taunt', 'charm', 'confuse'];
SG.HARD_CC = HARD_CC;
const pickLvl = (txt, lvl) => { const a = txt.replace(/[{}]/g, '').split('/').map(Number); return a[Math.min(a.length, Math.max(1, lvl)) - 1]; };
function nearSec(desc, idx, lvl) {
  const re = /(\{[^}]+\}|\d+(?:\.\d+)?)\s*秒/g;
  let m, best = null, bd = 1e9;
  while ((m = re.exec(desc))) { const d = Math.abs(m.index - idx); if (d < bd && d < 22) { bd = d; best = m[1]; } }
  return best ? pickLvl(best, lvl) : null;
}
function ccOf(sk, lvl) {
  if (sk.x) return SG.xcc(sk, lvl);
  sk._cc = sk._cc || {};
  if (sk._cc[lvl] !== undefined) return sk._cc[lvl];
  const desc = sk.desc.replace(/免疫緩速|解除緩速|解除控制|控制時間|不受任何控制|不會被控制|無法被控制|被控制/g, '＿＿');
  const cc = {};
  for (const [k, re, def] of CC_KEYS) {
    const m = desc.match(re);
    if (!m) continue;
    const v = nearSec(desc, m.index, lvl);
    cc[k] = v != null && v < 10 ? v : def;
  }
  if (/擊退/.test(desc)) cc.knockback = 60;
  const sm = desc.match(/(?:緩速|減速|移速 -)\s*(\{[^}]+\}|\d+)%/);
  if (sm) { const v = nearSec(desc, sm.index, lvl); cc.slow = [pickLvl(sm[1], lvl) / 100, v != null && v < 10 ? v : 1.5]; }
  if (/最後一段|最後一擊|第三段|第三刺|最後一圈/.test(desc)) cc.last = true;
  sk._cc[lvl] = Object.keys(cc).length ? cc : null;
  return sk._cc[lvl];
}
SG.ccOf = ccOf;
// 被動技能：讀出數值加成；有條件的（「…時」「每…」「附近…」）以 60% 計
function passiveOf(sk, lvl) {
  if (sk.pv) return SG.xpv(sk, lvl);
  sk._pv = sk._pv || {};
  if (sk._pv[lvl]) return sk._pv[lvl];
  const d = sk.desc, o = {}, cond = /時|每|附近|若|當/.test(d) ? 0.6 : 1;
  const get = (re) => { const m = d.match(re); return m ? pickLvl(m[1], lvl) : 0; };
  o.atk = get(/攻擊 \+(\{[^}]+\})(?!%)/) * cond;
  o.armor = get(/護甲 \+(\{[^}]+\})/) * cond;
  o.asp = get(/攻速 \+(\{[^}]+\})/) * cond;
  o.ms = get(/移速 \+(\{[^}]+\})/) * (/移速 \+\{[^}]+\}%/.test(d) ? 3 : 1) * cond;
  o.sp = get(/技能傷害 \+(\{[^}]+\})%/) * cond;
  o.cdr = get(/冷卻 -(\{[^}]+\})%/) * cond;
  o.range = get(/普攻射程 \+(\{[^}]+\})/);
  const pm = d.match(/普攻有 (\{[^}]+\})% 機率/);
  if (pm) { o.proc = pickLvl(pm[1], lvl) / 100; o.procCC = ccOf(sk, lvl); if (/破甲/.test(d)) o.procShred = true; }
  const mm = d.match(/普攻同時射出 (\{[^}]+\}) 支箭/);
  if (mm) o.multi = pickLvl(mm[1], lvl);
  const bm = d.match(/普攻讓目標燃燒.*?(\{[^}]+\})/);
  if (bm) o.burnHit = pickLvl(bm[1], lvl);
  sk._pv[lvl] = o;
  return o;
}
SG.passiveOf = passiveOf;

function mkStatus() {
  return { stun: 0, root: 0, slow: 0, slowAmt: 0, fear: 0, fearDir: 1, silence: 0, invis: 0, shield: 0, shieldT: 0, atkUp: 0, atkUpAmt: 0, msUp: 0, msUpAmt: 0, dr: 0, drAmt: 0, regen: 0, regenAmt: 0, burn: 0, burnDps: 0, burnSrc: null,
    knockup: 0, down: 0, freeze: 0, taunt: 0, tauntBy: null, charm: 0, charmBy: null, confuse: 0, cdir: [1, 0], cT: 0, disarm: 0, ccRes: 0, ccStack: 0, ccBy: null, shred: 0, rattan: 0, convert: 0, convertAmt: 0, chainFire: false, weak: 0 };
}
function unit(o) {
  return Object.assign({
    id: uid++, x: 0, y: 0, f: 1, r: 22, alive: true, hp: 100, maxHp: 100, mp: 0, maxMp: 0, atk: 10, armor: 0, asp: 100, ms: 280, range: 80,
    act: null, atkCd: 0, stagger: 0, st: mkStatus(), anim: 'idle', animSeq: 0, loop: 'idle', vis: [true, true], input: {}, deadT: 0, dmgBy: {},
  }, o);
}

// 地面度量的位移（dy 為度量值，實際 y 位移乘上 K）。撞到樹時沿樹緣滑開，而不是分軸硬停
const BODY = M.BODY;
function move(u, dx, dy) {
  dy *= K;
  const step = Math.hypot(dx, dy);
  if (!step) return false;
  let p = [u.x + dx, u.y + dy];
  if (!M.walkable(p[0], p[1], BODY)) p = M.pushOut(p[0], p[1], BODY);
  if (!M.walkable(p[0], p[1], BODY) && !M.walkable(u.x, u.y, BODY)) p = M.nearestFree(u.x, u.y);
  // 夾在兩棵樹之間推不乾淨：原地留著；原地本來就卡在樹裡就照推出去的位置走
  if (!M.walkable(p[0], p[1], BODY) && M.walkable(u.x, u.y, BODY)) return false;
  const moved = Math.hypot(p[0] - u.x, p[1] - u.y);
  u.x = p[0]; u.y = p[1];
  return moved > step * 0.2;
}
SG.move = move;
SG.unit = unit; // 列傳任務自己生單位（敵兵、鄉勇、敵將）
function clearLine(x0, y0, x1, y1) { return M.segClear(x0, y0, x1, y1, BODY); }
SG.clearLine = clearLine;
// 沿直線找最遠可落腳點（瞬移、躍擊用）
function landing(x0, y0, x1, y1) {
  for (let k = 1; k >= 0; k -= 0.05) {
    const x = x0 + (x1 - x0) * k, y = y0 + (y1 - y0) * k;
    if (M.walkable(x, y, BODY)) return [x, y];
    if (M.walkable(x, y)) { const p = M.pushOut(x, y, BODY); if (M.walkable(p[0], p[1], BODY)) return p; }
  }
  return [x0, y0];
}

const atBaseOf = (u) => Math.hypot(u.x - M.bases[u.team].x, u.y - M.bases[u.team].y) < M.shopR + 80;
// 視野半徑（地面度量）：建築與武將看得遠，小兵近
const sightOf = (u) => (u.structure ? 900 : u.kind === 'hero' ? 850 : u.kind === 'ward' ? 900 : 650) * (u.sightK || 1); // sightK：列傳地圖縮短視野
SG.sightOf = sightOf;

class World {
  constructor(opts) {
    SG.rand = opts.seed != null ? SG.seeded(opts.seed) : Math.random;
    if (opts.seed != null) uid = 1; // 錄影比對：每一場的單位編號都從 1 開始
    this.t = 0; this.units = []; this.projs = []; this.zones = []; this.feed = []; this.msgs = []; this.dmgEvents = []; this.vfx = [];
    this.kills = [0, 0]; this.over = null; this.waveT = 4; this.wave = 0; this.firstBlood = false;
    // 速戰：約 10 分鐘一局（建築血少、出兵快、經驗金錢多、復活快），給隨手開一局的玩家
    this.mode = opts.mode === 'quick' ? 'quick' : 'std';
    // 連線模式的規則（M4 P3）：開放的路線、每隊人數、只能陣亡時買裝（大亂鬥）、單挑勝負、合作模式難度
    this.lanes = (opts.lanes || ['top', 'mid', 'bot']).filter((l) => M.lanes[l]);
    this.size = opts.size || 5;
    this.rules = { buyDead: !!opts.buyDead, solo: !!opts.solo, diff: opts.diff || null };
    const Q = this.mode === 'quick';
    this.tune = Q ? { bld: 0.55, wave: 18, respawn: 0.6, exp: 1.6, wage: 4, gold: 1200, lv: 3 } : { bld: 1, wave: 25, respawn: 1, exp: 1, wage: 2, gold: 600, lv: 1 };
    this.bossT = Q ? 60 : 90; this.boss = null;
    // 地圖機制：東風、傳國玉璽、糧草車
    this.wind = { on: 0, next: Q ? 60 : 120 };
    // 傳國玉璽（v0.3.0）：開戰 3 分鐘出現在下游沙洲（呂布的鏡像位置）；5 點血，只有武將普攻算、每下 1，另一隊打一下就重置
    this.seal = { state: 'wait', t: 180, x: 2 * M.center[0] - M.boss.x, y: 2 * M.center[1] - M.boss.y, holder: null, gt: 0, unit: null, team: -1 };
    this.cartT = 45; this.supply = [0, 0];
    M.towers.forEach((t) => this.units.push(unit({
      kind: 'tower', structure: true, team: t.team, lane: t.lane, tier: t.tier, x: t.x, y: t.y, r: 44, hp: 2200, maxHp: 2200, atk: [150, 165, 180, 195][t.tier - 1], armor: 12, range: 520, name: '城寨', rate: 1.0, inner: t.inner,
    })));
    M.granaries.forEach((t) => this.units.push(unit({ kind: 'granary', structure: true, team: t.team, lane: t.lane, x: t.x, y: t.y, r: 40, hp: 1600, maxHp: 1600, atk: 0, armor: 8, range: 0, name: '糧倉', rate: 1 })));
    M.barracks.forEach((t) => this.units.push(unit({ kind: 'barracks', structure: true, team: t.team, lane: t.lane, x: t.x, y: t.y, r: 40, hp: 1800, maxHp: 1800, atk: 0, armor: 10, range: 0, name: '兵營', rate: 1 })));
    // 沒開放的路線：城寨、兵營、糧倉都不設
    this.units = this.units.filter((u) => !u.lane || this.lanes.includes(u.lane));
    M.bases.forEach((b, i) => this.units.push(unit({ kind: 'base', structure: true, team: i, x: b.x, y: b.y, r: 90, hp: 4500, maxHp: 4500, atk: 320, armor: 15, range: 620, name: '本營', rate: 0.7 })));
    if (Q) this.units.forEach((u) => { if (u.structure) u.hp = u.maxHp = Math.round(u.maxHp * this.tune.bld); });
    this.baseUnits = this.units.filter((u) => u.kind === 'base');
    this.granary = [0, 1].map((T) => this.units.find((u) => u.kind === 'granary' && u.team === T));
    this.camps = M.camps.map((c) => ({ c, t: 30, units: [] }));
    // mixed：測試用，兩邊都從全部武將裡抽，用來分辨是地圖還是名單造成的不平衡
    const pool = opts.mixed ? [SG.HEROES.slice(), SG.HEROES.slice()] : [SG.HEROES.filter((h) => h.faction !== 'wei'), SG.HEROES.filter((h) => h.faction === 'wei')];
    const pick = (team, n, not) => {
      const list = pool[team].filter((h) => !not.some((n) => n.id === h.id)); // 比 id：玩家帶的可能是換了造型的副本
      const out = [];
      while (out.length < n && list.length) out.push(list.splice((SG.rand() * list.length) | 0, 1)[0]);
      return out;
    };
    if (opts.slots) {
      // 連線：每個真人一個位置，其餘由電腦補滿（每隊 5 人）
      // bot：禁選時電腦座位已經選好的武將，照樣由電腦操作
      opts.slots.forEach((sl) => { const u = this.addHero(sl.spec, sl.team, false); if (sl.bot) return; u.ml = sl.ml && SG.ML && SG.ML[sl.ml] ? sl.ml : null; u.human = true; u.pid = sl.pid; u.name = sl.name ? `${sl.spec.name}（${sl.name}）` : u.name; });
      for (let team = 0; team < 2; team++) {
        if (opts.noFill && opts.slots.some((sl) => sl.team === team && !sl.bot)) continue; // 一般房關掉補電腦：有真人的隊伍不補（沒人的隊伍照補，例如合作模式的魏軍）
        const used = this.heroes().map((h) => h.spec);
        pick(team, this.size - this.heroes(team).length, used).forEach((h) => this.addHero(h, team, false));
      }
      this.heroes().filter((h) => h.human).forEach((h) => this.setManual(h));
      this.player = this.heroes().find((h) => h.human) || this.heroes()[0];
    } else {
      const pt = opts.hero.faction === 'wei' ? 1 : 0;
      this.player = this.addHero(opts.hero, pt, true);
      this.player.human = true; this.setManual(this.player);
      this.player.ml = opts.ml && SG.ML && SG.ML[opts.ml] ? opts.ml : null; // 單機：帶進場的謀略（訪客沒有）
      pick(pt, 4, [opts.hero]).forEach((h) => this.addHero(h, pt, false));
      pick(1 - pt, 5, []).forEach((h) => this.addHero(h, 1 - pt, false));
    }
    if (this.tune.lv > 1) this.heroes().forEach((h) => this.addExp(h, SG.expToLevel(this.tune.lv) / this.tune.exp, true));
    SG.AI.assign(this);
  }

  heroes(team) { return this.units.filter((u) => u.kind === 'hero' && (team === undefined || u.team === team)); }

  addHero(spec, team, isPlayer) {
    const b = M.bases[team];
    const u = unit({ kind: 'hero', spec, team, isPlayer, name: spec.name, x: b.x + (team ? -120 : 120), y: b.y + (SG.rand() - 0.5) * 200, f: team ? -1 : 1, lv: 1, exp: 0, gold: this.tune.gold,
      items: [null, null, null, null, null, null], icd: [0, 0, 0, 0, 0, 0], iq: [0, 0, 0, 0, 0, 0], skillLv: [0, 0, 0, 0], cd: [0, 0, 0, 0], kills: 0, deaths: 0, assists: 0, respawn: 0, ranged: !!spec.ranged, r: 24 });
    u.skillLv = SG.skillLevels(spec, 1).L;
    u.ml = SG.botMoulue ? SG.botMoulue(spec) : null; u.mlCd = 0; // 謀略：電腦依定位帶；真人在下面改成自己選的（訪客沒有）
    // 戰績：給結算、戰功與每日軍令用
    u.stat = { dmgHero: 0, dmgBld: 0, taken: 0, heal: 0, carts: 0, towers: 0, boss: 0, seal: 0, maxMulti: 0, maxStreak: 0, fb: 0, grabs: 0, chase: 0, blocked: 0 };
    this.recalc(u, true);
    this.units.push(u);
    return u;
  }

  // 真人玩家自己配點：每升一級一點，可點技能或「屬性加強」（每點全屬性 +2）
  setManual(u) { u.manual = true; u.skillLv = [0, 0, 0, 0]; u.attr = 0; u.pts = u.lv; this.recalc(u, true); }
  canLearn(u, i) {
    if (!u.manual || !(u.pts > 0)) return '沒有技能點';
    if (i === 4) return u.attr >= 10 ? '屬性加強已滿' : '';
    const cur = u.skillLv[i], max = i === 3 ? 3 : 4;
    if (cur >= max) return '已滿級';
    if (i === 3 ? u.lv < 6 + cur * 5 : cur + 1 > Math.ceil(u.lv / 2)) return `要 ${i === 3 ? 6 + cur * 5 : cur * 2 + 1} 級才能學`;
    return '';
  }
  learn(u, i) {
    const why = this.canLearn(u, i);
    if (why) { this.tell(u, why, 'warn'); return false; }
    u.pts--;
    if (i === 4) u.attr++; else u.skillLv[i]++;
    this.recalc(u);
    this.tell(u, i === 4 ? `屬性加強 ${u.attr}（全屬性 +${u.attr * 2}）` : `${u.spec.skills[i].name} 升到 ${u.skillLv[i]} 級`, 'good');
    return true;
  }
  recalc(u, full) {
    const s = SG.stats(u.spec, u.lv, u.seal ? u.items.concat([SG.ITEM.yuxi]) : u.items, u.manual ? u.attr : undefined);
    const pv = { atk: 0, armor: 0, asp: 0, ms: 0, sp: 0, cdr: 0, range: 0 };
    u.procs = [];
    u.spec.skills.forEach((sk, i) => {
      if (!sk.passive || !u.skillLv[i]) return;
      const o = passiveOf(sk, u.skillLv[i]);
      for (const k in pv) pv[k] += o[k] || 0;
      if (o.proc || o.burnHit) u.procs.push(o);
      if (o.multi) u.multi = Math.max(u.multi || 1, o.multi);
    });
    const hpR = full ? 1 : u.hp / u.maxHp, mpR = full ? 1 : u.maxMp ? u.mp / u.maxMp : 1;
    u.maxHp = s.hp; u.maxMp = s.mp; u.atk = Math.round(s.atk + pv.atk); u.armor = s.armor + pv.armor; u.asp = Math.round(s.as * (1 + pv.asp / 100)); u.ms = Math.round(s.ms + pv.ms); // 被動的攻速 +X% 也是乘上去；移速每次都從基礎值重算（v0.4.2.1：之前這行被註解吃掉，移速被動越乘越大、坐騎沒作用）
    u.range = (u.ranged ? 430 : 90) + pv.range; u.cdr = Math.min(40, s.cdr + pv.cdr); u.sp = s.sp + pv.sp;
    u.mr = s.mr; u.apen = s.apen; u.mpen = s.mpen; u.matk = s.matk; u.str = s.str; u.agi = s.agi; u.int = s.int; u.main = s.main; // v0.3.0 數值
    this.xRecalc(u);
    if (u.diffMul) { u.maxHp = Math.round(u.maxHp * u.diffMul); u.atk = Math.round(u.atk * u.diffMul); } // 合作模式難度
    if (SG.isNeng(u)) u.maxMp = SG.NENG.max; // 能：上限不吃智力與裝備
    if (SG.noRes(u)) u.maxMp = 0; // 不耗資源：沒有氣條
    u.hp = u.maxHp * hpR; u.mp = u.maxMp * mpR;
  }

  // ---------- 主迴圈 ----------
  step(dt) {
    if (this.over !== null) return;
    this.t += dt;
    this.spawnWaves(dt); this.campTick(dt); this.bossTick(dt); this.xAuras(dt);
    this.windTick(dt); this.sealTick(dt); this.cartTick(dt);
    // 先挑出到期的再執行：到期的函式若又排了新的延遲（連鎖），才不會被這次的 filter 吞掉
    if (this.timers && this.timers.length) { const due = []; this.timers = this.timers.filter((tm) => { tm.t -= dt; if (tm.t <= 0) { due.push(tm); return false; } return true; }); due.forEach((tm) => tm.fn()); }
    for (const u of this.units) this.tickStatus(u, dt);
    this.visibility();
    for (const u of this.units) {
      if (u.kind === 'hero' && u.input.learn != null) { this.learn(u, u.input.learn); u.input.learn = null; }
      if (!u.alive) continue;
      if (u.kind === 'hero') { if (!u.human) SG.AI.tick(this, u, dt); this.control(u, dt); }
      else if (u.structure) { if (u.atk) this.towerAI(u, dt); }
      else if (u.kind === 'cart') this.cartMove(u, dt);
      else if (u.kind !== 'ward' && u.kind !== 'seal') { this.creepAI(u, dt); if (u.still) this.xStill(u); this.control(u, dt); }
    }
    this.separate();
    this.updateThrown(dt);
    this.updateProjs(dt); this.updateZones(dt); this._el = null; this._src = null;
    if (this.elTick) this.elTick(dt);
    for (const u of this.heroes()) {
      if (!u.alive) { u.respawn -= dt; if (u.respawn <= 0) this.revive(u); continue; }
      u.gold += (!this.granary[u.team] || this.granary[u.team].alive ? this.tune.wage : this.tune.wage / 2) * dt; // 糧倉還在（或這個模式沒有糧倉）才有全額軍餉
      if (u.rc) this.rcTick(u);
      for (const h of H_HERO_EARLY) h.fn.call(this, u, dt);
      if (!atBaseOf(u)) { u.laneT = (u.laneT || 0) - dt; if (u.laneT <= 0) { u.laneT = 1; u.lane0 = M.laneNear(u.x, u.y); } }
    }
    this.units = this.units.filter((u) => u.alive || u.kind === 'hero' || u.structure || this.t - u.deadT < 2);
    for (const u of this.units) if (u.structure && !u.alive && this.t - u.deadT > 3) u.gone = true;
    if (this.msgs.length > 20) this.msgs.splice(0, this.msgs.length - 20);
    if (this.feed.length > 30) this.feed.splice(0, this.feed.length - 30);
    if (this.vfx.length > 200) this.vfx.splice(0, this.vfx.length - 200);
  }

  tickStatus(u, dt) {
    const s = u.st;
    if (u.ml || u.ign || u.tp || u.unarmor) this.mlTick(u, dt); // 謀略（moulue.ts）
    const wasDown = s.down > 0;
    for (const k of ['stun', 'root', 'slow', 'fear', 'silence', 'invis', 'shieldT', 'atkUp', 'msUp', 'dr', 'regen', 'burn', 'knockup', 'down', 'freeze', 'taunt', 'charm', 'confuse', 'disarm', 'ccRes', 'shred', 'rattan', 'convert', 'weak']) if (s[k] > 0) s[k] = Math.max(0, s[k] - dt);
    if (wasDown && s.down <= 0 && u.alive) { u.anim = 'idle'; u.animSeq++; } // 擊倒後起身
    if (s.ccRes <= 0) s.ccStack = 0;
    // 連環：著火的敵人把火延燒給 90 內的隊友（每秒一次機會）
    if (s.burn > 0 && s.chainFire && s.burnSrc && u.alive && SG.rand() < dt) {
      const n = this.units.find((o) => o !== u && o.alive && o.team === u.team && !o.structure && o.st.burn <= 0 && gd(o.x, o.y, u.x, u.y) < 90);
      if (n) { Object.assign(n.st, { burn: 2.5, burnDps: s.burnDps, burnSrc: s.burnSrc, burnFire: true, chainFire: true }); this.fx({ k: 'fire', x: n.x, y: n.y, pal: 'fire', small: 1 }); }
    }
    if (s.shieldT <= 0) s.shield = 0;
    if (u.stagger > 0) u.stagger -= dt;
    if (u.atkCd > 0) u.atkCd -= dt;
    if (u.kind === 'ward') {
      if (!u.alive) return; // 死掉的眼不再計時（v0.4.2.2：之前每格把 deadT 重設成現在，永遠清不掉）
      u.life -= dt; if (u.life <= 0) { u.alive = false; u.deadT = this.t; return; }
      if (u.follow) { if (!u.follow.alive) { u.alive = false; u.deadT = this.t; return; } u.x = u.follow.x; u.y = u.follow.y; }
      // 貓頭鷹飛向目的地（飛行單位，不受樹林阻擋）
      if (u.fly) { const d = Math.hypot(u.fly[0] - u.x, (u.fly[1] - u.y) / K), s = Math.min(d, 560 * dt); if (d > 1) { u.f = Math.sign(u.fly[0] - u.x) || u.f; u.x += ((u.fly[0] - u.x) / d) * s; u.y += ((u.fly[1] - u.y) / d) * s; } }
      return;
    }
    if (!u.alive) return;
    if (u.buffs || u.px || u.dots) this.xTickUnit(u, dt);
    if (!u.alive) return;
    if (u.cd) for (let i = 0; i < 4; i++) if (u.cd[i] > 0) u.cd[i] -= dt;
    if (u.cds) for (const c of u.cds) if (c !== u.cd) for (let i = 0; i < 4; i++) if (c[i] > 0) c[i] -= dt; // 形態：沒在用的那組冷卻照跑
    if (u.icd) for (let i = 0; i < 6; i++) if (u.icd[i] > 0) u.icd[i] -= dt;
    if (u.kind === 'hero') {
      // 溫泉守護：闖進敵方溫泉區（本營周圍）每秒損失 12% 最大生命
      const eb = this.baseUnits[1 - u.team];
      if (eb && eb.alive && Math.hypot(u.x - eb.x, u.y - eb.y) < M.shopR) {
        this.damage(eb, u, u.maxHp * 0.12 * dt, { magic: true, quiet: true });
        if (!u.springT || this.t - u.springT > 4) { u.springT = this.t; this.tell(u, '闖進敵方溫泉區：每秒損失 12% 生命！', 'warn'); }
        if (!u.alive) return;
      }
      const atBase = Math.hypot(u.x - M.bases[u.team].x, u.y - M.bases[u.team].y) < M.shopR;
      u.hp = Math.min(u.maxHp, u.hp + (atBase ? u.maxHp * 0.08 : u.maxHp * 0.004 + (s.regen > 0 ? s.regenAmt : 0)) * dt);
      u.mp = Math.min(u.maxMp, u.mp + (SG.isNeng(u) ? SG.NENG.regen : atBase ? u.maxMp * 0.08 : u.maxMp * 0.012) * dt);
    }
    if (s.burn > 0 && s.burnSrc) this.damage(s.burnSrc, u, s.burnDps * dt, { magic: true, quiet: true, fire: s.burnFire });
  }

  // 戰爭迷霧：敵方與中立單位要在我方任一單位的視野內才看得到；建築永遠可見。
  // 隱身或躲在蘆葦裡的，還要靠得夠近（箭塔與斥候旗看得遠）或站進同一叢蘆葦。
  visibility() {
    const rev = [[], []];
    for (const v of this.units) if (v.alive && v.team < 2) rev[v.team].push(v);
    for (const u of this.units) {
      if (!u.alive) continue;
      const br = u.structure ? -1 : M.brushAt(u.x, u.y);
      u.brush = br;
      for (let T = 0; T < 2; T++) {
        if (u.team === T || u.structure || u.kind === 'seal') { u.vis[T] = true; continue; } // 持有玉璽不再暴露位置（v0.3.0：沒有代價）
        const invis = u.st.invis > 0, hidden = !(u.revealT > this.t) && (invis || br >= 0);
        let seen = false;
        for (const v of rev[T]) {
          const d = gd(v.x, v.y, u.x, u.y);
          if (!hidden) { if (d < sightOf(v)) { seen = true; break; } continue; }
          if (v.owl && invis) continue; // 貓頭鷹看不見隱身單位
          if (d < (v.kind === 'ward' ? 420 : v.structure ? 520 : 150) || (br >= 0 && v.brush === br && !invis)) { seen = true; break; }
        }
        u.vis[T] = seen;
      }
    }
  }

  // ---------- 操作 ----------
  speed(u) {
    let s = u.ms;
    if (u.st.slow > 0) s *= 1 - u.st.slowAmt;
    // 移速加成只取最大的一個（v0.4.2.1：不同來源不相加，最快的組合才算得出來、不超過 MS_CAP）；緩速照舊相加
    const up = Math.max(u.st.msUp > 0 ? u.st.msUpAmt : 0, u.bf ? u.bf.msUp : 0);
    if (up > 0) s *= 1 + up;
    if (u.bf && u.bf.ms < 0) s *= Math.max(0.2, 1 + u.bf.ms);
    if (u.kind === 'hero') s *= SG.HERO_MS; // 武將整體移速倍率（2026-10-02 使用者覺得太快）
    s += u.msFlat || 0; // 固定加值（臧霸「青徐之主」）不受倍率影響
    return Math.min(SG.MS_CAP, s); // 安全網：正常數值碰不到（tests/movespeed.cjs 窮舉最快的組合）
  }
  control(u, dt) {
    const I = u.input, s = u.st;
    u.defending = false;
    if (I.stop) { I.stop = false; I.engage = false; I.target = null; I.autoId = null; I.amove = null; I.moveTo = null; I.castOn = null; I.wp = null; I.wpAdd = null; } // S：中止攻擊狀態，路徑也清掉
    // 攻擊狀態由模擬端持有：客戶端只送單次的「脫離」（右鍵移動）、「進入」（A 點擊、右鍵點敵人、觸控點敵人）
    if (I.disengage) { I.disengage = false; if (!u.mounted) { I.engage = false; I.autoId = null; } } // 右鍵移動結束攻擊狀態；曹彰騎射（上馬）例外
    if (I.engageReq) { I.engageReq = false; I.engage = true; }
    // 路徑點（v0.3.8，Shift＋右鍵，像世紀帝國）：wpAdd 追加、wpClr 清空（一般指令會清）；走到目前的目的地就接下一個
    if (I.wpClr) { I.wpClr = false; I.wp = null; }
    if (I.wpAdd) { const a = I.wpAdd; I.wpAdd = null; I.wp = (I.wp || []).concat(a).slice(0, 12); if (!I.moveTo) I.moveTo = I.wp.shift(); }
    if (I.ml) { const q = I.ml; I.ml = null; const e = this.castMoulue(u, q); if (e) this.tell(u, e, 'warn'); }
    if (u.tp) { u.loop = 'idle'; I.hard = I.cancel = false; return; } // 支援引導中：不能動（mlTick 在下一步之前已檢查中斷）
    if (u.slashing) { u.loop = 'idle'; return; } // 引導中（周泰十二創），不接受操作
    if (I.recall && !u.act) { I.recall = false; this.startRecall(u); } // 出手中按 B：等這個動作結束再開始回城
    // 開關技立刻切換，不打斷、也不等目前的動作
    if (I.skill && u.spec && u.spec.skills && u.spec.skills[I.skill.i] && u.spec.skills[I.skill.i].tg) { this.tryCast(u, I.skill.i); I.skill = null; }
    if (u.recall && this.recallTick(u, dt)) return;
    if (u.grabbedBy || u.thrown) { u.loop = 'idle'; return; }
    if (s.stun > 0 || u.stagger > 0) { if (u.grab) this.release(u); u.loop = 'idle'; I.cancel = I.hard = false; return; }
    if (u.grab) { this.holdTick(u, dt); return; }
    if (s.freeze > 0 || s.knockup > 0 || s.down > 0) { u.loop = 'idle'; return; }
    if (s.fear > 0) { u.f = s.fearDir; move(u, s.fearDir * this.speed(u) * 0.8 * dt, 0); u.loop = 'run'; return; }
    if (s.charm > 0 && s.charmBy && s.charmBy.alive) { const d = dirTo(u, s.charmBy.x, s.charmBy.y); u.f = sign(d[0]) || u.f; move(u, d[0] * this.speed(u) * 0.5 * dt, d[1] * this.speed(u) * 0.5 * dt); u.loop = 'walk'; return; }
    if (s.confuse > 0) {
      if ((s.cT -= dt) <= 0) { s.cT = 0.4; const a = SG.rand() * Math.PI * 2; s.cdir = [Math.cos(a), Math.sin(a)]; }
      u.f = sign(s.cdir[0]) || u.f; move(u, s.cdir[0] * this.speed(u) * 0.7 * dt, s.cdir[1] * this.speed(u) * 0.7 * dt); u.loop = 'walk'; return;
    }
    if (s.taunt > 0 && s.tauntBy && s.tauntBy.alive && !u.act) {
      const t = s.tauntBy;
      if (this.inRange(u, t)) { u.f = sign(t.x - u.x) || u.f; u.loop = 'idle'; if (u.atkCd <= 0) this.startAttack(u, t); }
      else this.goToward(u, t.x, t.y, dt);
      return;
    }
    // 免動作技（周泰「刀舞」）：不進施法動作，走路、普攻都不中斷，按下立即生效
    if (I.skill && u.spec && u.spec.skills && u.spec.skills[I.skill.i] && u.spec.skills[I.skill.i].free) { const q = I.skill; I.skill = null; this.tryCast(u, q.i, q.x, q.y); }
    if (u.act) {
      const k = u.act.t / u.act.dur, next = I.skill;
      // 普攻：出手後移動可取消收招；出手前下新指令則整個取消並退回冷卻
      if (u.act.kind === 'attack' && (I.cancel || I.hard)) {
        if (k >= 0.44) this.endAct(u);
        else if (I.hard) { this.endAct(u); u.atkCd = 0; }
      }
      // v0.3.0：技能最後一段效果出手後，移動／攻擊指令可以直接取消收招（不用等動作播完）
      else if (u.act.kind === 'skill' && (I.cancel || I.hard) && k >= (u.act.rel || 0.8)) this.endAct(u);
      // 連段：普攻出手後、技能最後一段效果之後，可直接接技能／跳躍／抓人
      else if (next && ((u.act.kind === 'attack' && k >= 0.44) || (u.act.kind === 'skill' && k >= (u.act.rel || 0.8)))) {
        if (u.human && u.act.kind === 'skill') this.dmgEvents.push({ x: u.x, y: u.y - 40, text: '連段', team: u.team, src: u.id });
        this.endAct(u);
      }
      I.cancel = I.hard = false;
      if (u.act) { this.progressAct(u, dt); return; }
    }
    if (I.item != null) { this.useItem(u, I.item); I.item = null; }
    if (I.skill) {
      const q = I.skill; I.skill = null; I.castOn = null;
      const sk = u.spec.skills && u.spec.skills[q.i];
      if (q.tid && sk && !sk.passive && SG.aimOf(sk, u.skillLv[q.i] || 1).kind === 'unit') {
        // 點擊技：鎖定點選的目標；在射程外就先走過去（途中下其他指令就取消）
        const t = this.units.find((o) => o.id === q.tid);
        if (t && t.alive) {
          const R = this.skillRange(sk, u.skillLv[q.i] || 1);
          if (gd(u.x, u.y, t.x, t.y) > R + t.r + 10 && u.cd[q.i] <= 0 && u.st.silence <= 0) { I.castOn = { i: q.i, tid: q.tid }; I.moveTo = null; I.amove = null; I.hard = false; }
          else { this._castTid = t.id; const ok = this.tryCast(u, q.i, t.x, t.y); this._castTid = null; if (ok) return; }
        }
      } else if (this.tryCast(u, q.i, q.x, q.y)) return;
    }
    if (I.castOn) {
      const c = I.castOn, t = this.units.find((o) => o.id === c.tid), sk = u.spec.skills[c.i];
      if (I.hard || I.moveTo || I.amove || !t || !t.alive || !(t.team === 2 ? u.team !== 2 : this.isEnemy(u, t) || t.team === u.team)) I.castOn = null;
      else if (gd(u.x, u.y, t.x, t.y) <= this.skillRange(sk, u.skillLv[c.i] || 1) + t.r) { I.castOn = null; this._castTid = t.id; const ok = this.tryCast(u, c.i, t.x, t.y); this._castTid = null; if (ok) return; }
      else { this.goToward(u, t.x, t.y, dt); return; }
    }
    I.jump = I.grab = false; // 跳躍、抓人已移除（抓人改成周倉「擒將」）
    if (I.defend) {
      u.defending = true; u.loop = 'defend';
      if (I.aim) u.f = sign(I.aim[0] - u.x) || u.f;
      return;
    }
    // 攻擊狀態（v0.3.8）：A 點敵人／地面、右鍵點敵人、攻擊鍵都會進入；目標死了或跑掉就自動找下一個，只有 S 會中止。
    // 防禦（D）、移動、施法都只是暫時蓋過去，結束後回到攻擊狀態
    if (I.attack && s.disarm <= 0) I.engage = true;
    if (I.attack && s.disarm <= 0 && !(I.target && I.target.alive)) {
      const best = this.autoTarget(u);
      if (best) { I.target = best; I.autoId = best.id; }
      else if (u.atkCd <= 0) { this.startAttack(u, null, I.aim); return; } // 警戒範圍內沒有敵人：原地朝面向揮
    }
    if (I.target && I.target.id === I.autoId && gd(u.x, u.y, I.target.x, I.target.y) > this.acquireRange(u) * 1.6) { I.target = null; I.autoId = null; }
    const steering = Math.abs(I.mx || 0) + Math.abs(I.my || 0) > 0.1;
    if ((I.engage || I.amove) && !I.moveTo && !steering) {
      const cur = I.target && I.target.alive ? I.target : null;
      // 自動挑的目標：有更高順位的敵人（例如武將走進射程）就換；玩家點的目標打到死為止
      if (!cur || cur.id === I.autoId) {
        const best = this.autoTarget(u);
        if (best && (!cur || (best !== cur && this.targetTier(u, best) < this.targetTier(u, cur, 60)))) { I.target = best; I.autoId = best.id; } // 現在的目標多給 60 的寬限，免得在射程邊緣來回換
      }
      if (!I.target && I.amove) {
        if (gd(u.x, u.y, I.amove[0], I.amove[1]) < 12) I.amove = null;
        else { this.goToward(u, I.amove[0], I.amove[1], dt); return; }
      }
    }
    if (I.target) {
      const t = I.target;
      if (!t.alive || !(t.team === 2 ? u.team !== 2 : this.isEnemy(u, t) || this.canDeny(u, t))) I.target = null;
      else {
        if (this.inRange(u, t)) {
          u.f = sign(t.x - u.x) || u.f; u.loop = 'idle';
          if (u.atkCd <= 0 && s.disarm <= 0) this.startAttack(u, t);
          return;
        }
        this.goToward(u, t.x, t.y, dt);
        return;
      }
    }
    if (I.moveTo) {
      if (gd(u.x, u.y, I.moveTo[0], I.moveTo[1]) < 10) { I.moveTo = I.wp && I.wp.length ? I.wp.shift() : null; if (!I.moveTo) { u.loop = 'idle'; return; } }
      this.goToward(u, I.moveTo[0], I.moveTo[1], dt);
      return;
    }
    const mx = I.mx || 0, my = I.my || 0, m = Math.hypot(mx, my);
    if (m > 0.1 && s.root <= 0) {
      if (Math.abs(mx) > 0.15) u.f = mx > 0 ? 1 : -1;
      const sp = this.speed(u) * Math.min(1, m) * dt;
      move(u, (mx / m) * sp, (my / m) * sp);
      u.loop = u.kind === 'hero' ? 'run' : 'walk';
    } else u.loop = 'idle';
  }
  acquireRange(u) { return Math.max(500, u.range + 150); }
  // 自動索敵順位（v0.3.8）：射程內武將 → 射程內其他單位（小兵、塔、黃巾賊同一級）→ 射程外武將 → 射程外其他單位，同一級挑近的
  targetTier(u, t, slack = 0) { return (gd(u.x, u.y, t.x, t.y) <= u.range + t.r + slack ? 0 : 2) + (t.kind === 'hero' ? 0 : 1); }
  autoTarget(u) {
    const R = this.acquireRange(u);
    let best = null, bd = 1e18;
    for (const t of this.units) {
      // 呂布、玉璽不會被自動攻擊（要打就自己點）
      if (!this.isEnemy(u, t) || t.kind === 'boss' || t.kind === 'seal' || (t.structure && this.structureLocked(t)) || t.invuln) continue;
      const d = gd(u.x, u.y, t.x, t.y);
      if (d > R && !this.inRange(u, t)) continue;
      const score = this.targetTier(u, t) * 1e9 + d;
      if (score < bd) { bd = score; best = t; }
    }
    return best;
  }
  // 走向某點：直線可達就直走，否則沿導航圖
  goToward(u, x, y, dt) {
    if (u.st.root > 0) { u.loop = 'idle'; return; }
    const nav = u.nav || (u.nav = { path: null, goal: null, age: 0, chk: null, side: 1, detour: 0 });
    nav.age += dt;
    // 目標落在樹裡：改走到樹邊
    if (!M.walkable(x, y, BODY)) [x, y] = M.nearestFree(x, y);
    let tx = x, ty = y;
    if (!clearLine(u.x, u.y, x, y)) {
      if (!nav.path || !nav.goal || Math.hypot(nav.goal[0] - x, nav.goal[1] - y) > 150 || nav.age > 2.5) { nav.path = M.path(u.x, u.y, x, y); nav.goal = [x, y]; nav.age = 0; }
      while (nav.path.length > 1 && Math.hypot(nav.path[0][0] - u.x, nav.path[0][1] - u.y) < 50) nav.path.shift();
      if (nav.path.length > 1 && clearLine(u.x, u.y, nav.path[1][0], nav.path[1][1])) nav.path.shift();
      tx = nav.path[0][0]; ty = nav.path[0][1];
    } else nav.path = null;
    const d = gd(u.x, u.y, tx, ty);
    if (d < 3) { u.loop = 'idle'; nav.chk = null; return; }
    const sp = this.speed(u), s = Math.min(d, sp * dt);
    // 卡住偵測：0.4 秒內前進不到預期的三成，就重新尋路並往側邊繞一小段
    if (!nav.chk) nav.chk = { x: u.x, y: u.y, t: 0, exp: 0 };
    nav.chk.t += dt; nav.chk.exp += s;
    if (nav.chk.t >= 0.4) {
      if (gd(u.x, u.y, nav.chk.x, nav.chk.y) < nav.chk.exp * 0.3) { nav.path = null; nav.age = 99; nav.side = -nav.side; nav.detour = 0.35; }
      nav.chk = { x: u.x, y: u.y, t: 0, exp: 0 };
    }
    let dir = dirTo(u, tx, ty);
    if (nav.detour > 0) { nav.detour -= dt; dir = rot(dir, nav.side * 1.2); }
    if (Math.abs(dir[0]) > 0.15) u.f = sign(dir[0]);
    if (!move(u, dir[0] * s, dir[1] * s)) {
      // 正面撞上：依序試偏 45°、90°，先試上次繞的那一側
      for (const a of [0.8, -0.8, 1.57, -1.57]) { const r = rot(dir, a * nav.side); if (move(u, r[0] * s, r[1] * s)) { if (a < 0) nav.side = -nav.side; break; } }
    }
    u.loop = u.kind === 'hero' ? 'run' : 'walk';
  }
  inRange(u, t) { return gd(u.x, u.y, t.x, t.y) <= u.range + t.r; }
  // 反補：自己的小兵生命低於 40% 時可以打
  canDeny(u, t) { return u.kind === 'hero' && t.alive && t.team === u.team && t.kind === 'minion' && !t.summon && t.hp / t.maxHp < 0.15; }

  // ---------- 抓人、摔投、撿物 ----------
  // 能抓：小兵、黃巾賊，或露出破綻（硬直、暈眩、定身、恐懼、殘血）的敵將
  tryGrab(u) {
    let best = null, bd = 80;
    for (const t of this.units) {
      if (!this.isEnemy(u, t) || t.structure || t.kind === 'boss' || t.kind === 'cart' || t.grabbedBy || t.thrown || t.air) continue;
      const open = t.kind !== 'hero' || t.stagger > 0 || t.st.stun > 0 || t.st.root > 0 || t.st.fear > 0 || t.hp / t.maxHp < 0.25;
      const d = gd(u.x, u.y, t.x, t.y) - t.r;
      if (open && d < bd) { bd = d; best = t; }
    }
    if (!best) return false;
    u.grab = { t: best, time: 0 }; best.grabbedBy = u; if (u.stat) u.stat.grabs++; best.act = null; best.input = best.kind === 'hero' ? best.input : {};
    u.f = sign(best.x - u.x) || u.f; best.f = -u.f;
    u.anim = 'defend'; u.animSeq++; best.anim = 'hit'; best.animSeq++;
    if (u.human || best.human) this.dmgEvents.push({ x: best.x, y: best.y - 20, text: '抓住', team: best.team, src: u.id, tgt: best.id });
    return true;
  }
  holdTick(u, dt) {
    const g = u.grab, t = g.t, I = u.input;
    g.time += dt;
    if (!t.alive) { this.release(u); return; }
    const p = along(u.x, u.y, [u.f, 0], 46);
    if (M.walkable(p[0], p[1], BODY)) { t.x = p[0]; t.y = p[1]; }
    t.st.stun = Math.max(t.st.stun, 0.12);
    u.loop = 'defend';
    if (u.act) { this.progressAct(u, dt); if (u.act) return; }
    // 抓著時可以連打（最多三下），再按一次抓或 1.4 秒後摔出
    if ((I.attack || I.punch || I.target === t) && u.atkCd <= 0 && (g.punches || 0) < 3) { I.punch = false; g.punches = (g.punches || 0) + 1; this.startAttack(u, t); return; }
    if (I.grab || g.time > 1.4) {
      I.grab = false;
      const dir = I.aim ? dirTo(u, I.aim[0], I.aim[1]) : [u.f, 0];
      this.throwBody(u, t, dir);
    }
  }
  release(u) { if (u.grab) { u.grab.t.grabbedBy = null; u.grab = null; } }
  // 再施放窗口過了沒按第二次：直接進冷卻
  rcTick(u) {
    for (const i in u.rc) {
      const r = u.rc[i];
      if (!r || this.t < r.until) continue;
      u.rc[i] = null;
      if (r.alt) u.cd[i] = Math.max(u.cd[i], r.cd0 - (this.t - r.at)); // 兩段式：第一段的冷卻照算，開窗口的時間也算進去
      else u.cd[i] = Math.max(u.cd[i], this.skillCd(u, u.spec.skills[i], +i, u.skillLv[i]) - u.spec.skills[i].recast);
    }
  }
  throwBody(u, t, dir, keepAct) {
    this.release(u);
    t.thrown = { dir, time: 0.5, src: u, hit: {} };
    t.st.stun = Math.max(t.st.stun, 0.9); t.anim = 'fall'; t.animSeq++;
    u.f = sign(dir[0]) || u.f;
    if (!keepAct) this.startAct(u, 'attack').noHit = true;
    if (u.human || t.human) this.dmgEvents.push({ x: t.x, y: t.y - 20, text: '摔！', team: t.team, src: u.id, tgt: t.id });
  }
  updateThrown(dt) {
    for (const t of this.units) {
      const th = t.thrown;
      if (!th) continue;
      th.time -= dt;
      const ok = move(t, th.dir[0] * 560 * dt, th.dir[1] * 560 * dt);
      t.air = true;
      // 被摔出去的身體會撞倒路徑上的敵人（被拋回的隊友不會）
      if (!th.ally) for (const o of this.units) {
        if (o === t || th.hit[o.id] || !this.isEnemy(th.src, o) || o.structure || gd(o.x, o.y, t.x, t.y) > o.r + t.r) continue;
        th.hit[o.id] = 1; this.damage(th.src, o, 40 + th.src.atk * 0.4, { stagger: 0.5, knock: 30 });
      }
      if (th.time <= 0 || !ok) {
        t.thrown = null; t.air = false;
        if (th.ally) { this.fx({ k: 'puff', x: t.x, y: t.y }); if (t.alive) { t.anim = 'idle'; t.animSeq++; } continue; }
        this.damage(th.src, t, th.land != null ? th.land : 60 + th.src.atk * 0.9, { stun: th.stun || 0.6 });
        this.fx({ k: 'slam', x: t.x, y: t.y, col: '#d8cdb5', small: 1 });
        if (t.alive) { t.anim = 'hit'; t.animSeq++; }
      }
    }
  }
  startAct(u, kind, i) {
    const A = SG.buildAnims(u.spec);
    const name = kind === 'attack' ? 'attack' : kind === 'jump' ? 'jump' : 's' + i;
    u.act = { kind, name, i, t: 0, dur: A[name].dur, done: {} };
    u.anim = name; u.animSeq++;
    u.noPx = kind === 'skill' && !!MOVE_ARCH[u.spec.skills[i].arch];
    return u.act;
  }
  endAct(u) { u.act = null; u.air = false; u.noPx = false; if (u.anim !== 'idle') { u.anim = u.loop || 'idle'; u.animSeq++; } }
  startAttack(u, target, aim) {
    const a = this.startAct(u, 'attack');
    a.target = target || null;
    a.dir = target ? dirTo(u, target.x, target.y) : aim ? dirTo(u, aim[0], aim[1]) : [u.f, 0];
    if (Math.abs(a.dir[0]) > 0.05) u.f = sign(a.dir[0]);
    u.atkCd = Math.max(0.3, (u.kind === 'hero' ? 1.15 : 1.25) * 100 / SG.effAsp(u));
    if (u.rampTid && target && target.id !== u.rampTid) { u.rampN = 0; u.rampAs = 0; }
  }
  progressAct(u, dt) {
    const a = u.act, kp = a.t / a.dur;
    if (a.kind === 'attack' && u.bf && u.bf.as > 0) dt *= 1 + u.bf.as / 125; // 攻速加成也加快出手動作
    if (a.kind === 'skill' && a.fast) dt *= a.fast;
    a.t += dt;
    const k = a.t / a.dur;
    const cross = (x) => kp < x && k >= x;
    if (a.kind === 'attack') { if (cross(0.44)) this.attackHit(u, a); }
    else if (a.kind === 'jump') u.air = k > 0.15 && k < 0.85;
    else if (a.kind === 'skill') { this._el = SG.elOf ? SG.elOf(a.sk, u.spec && u.spec.id) : null; this._src = u.id; this._skCls = a.cls; this._xa = a; this._skShot = a.shot ? u : null; u.skG = a.g || 1; this.skillTick(u, a, kp, k, dt, cross); this._el = null; this._src = null; this._skCls = null; this._xa = null; this._skShot = null; }
    if (a.t >= a.dur) { u.act = null; u.air = false; u.noPx = false; u.skG = 1; }
  }

  atkPower(u) {
    let a = u.atk;
    if (u.st.atkUp > 0) a *= 1 + u.st.atkUpAmt;
    if (u.bf) a = Math.max(1, (a + u.bf.atk) * (1 + u.bf.atkP));
    if (u.st.invis > 0 && u.kind === 'hero') { a *= 1.5; u.st.invis = 0; }
    return a;
  }
  attackHit(u, a) {
    if (a.noHit) return;
    const dmg = this.xCrit(u, this.atkPower(u), a) * (u.kind === 'hero' && !u.ranged ? SG.MELEE_ATK : 1); // 近戰武將普攻（v0.3.0 改單體後補償）
    if (a.target && a.target.team === u.team) { // 反補
      if (!this.canDeny(u, a.target)) return;
      if (u.ranged) this.proj(u, { homing: a.target, speed: 800, dmg, shape: SG.rangedShape(u.spec), col: u.spec.fx, visual: true, deny: true });
      else this.damage(u, a.target, dmg, { deny: true });
      return;
    }
    const tg = this.tgShot(u); // 開關技開著：這一發附加火焰傷害並扣氣
    if (u.ranged) {
      const fire = tg && tg.fire, shape = fire ? 'fire' : SG.rangedShape(u.spec); // 依兵器（v0.3.4）
      const o = fire ? { dmg: dmg + tg.dmg, shape, col: '#ff8a3a', burn: true, el: 'fire' } : { dmg, shape, col: tg && tg.poison ? '#8dff6a' : u.spec.fx, poison: tg ? tg.poison : null };
      // 落日弓「貫日」：每第 pierceN 發改成穿透直線上所有敵人的長箭
      const pn = u.ifx && u.ifx.pierceN;
      if (pn && a.target && a.target.alive && (u.pierceC = (u.pierceC || 0) + 1) % pn === 0) { this.proj(u, Object.assign({ dir: dirTo(u, a.target.x, a.target.y), speed: 1000, range: u.range + 300, pierce: true, visual: true, basic: true, big: true }, o)); if (this.sigFired) this.sigFired(u); }
      else if (a.target && a.target.alive) this.proj(u, Object.assign({ homing: a.target, speed: 800, visual: true, basic: true }, o));
      else this.proj(u, Object.assign({ dir: a.dir, speed: 700, range: u.range, visual: true, basic: true }, o));
      // 多重箭：同時分射附近其他敵人，額外的箭 50% 傷害
      const nm = Math.max(u.multi || 1, u.bf ? u.bf.multi : 0);
      if (nm > 1) {
        const main = a.target, c = main || { x: u.x + a.dir[0] * u.range * 0.6, y: u.y + a.dir[1] * u.range * 0.6 * K };
        this.units.filter((t) => t !== main && this.isEnemy(u, t) && !t.structure && gd(u.x, u.y, t.x, t.y) <= u.range + t.r && gd(c.x, c.y, t.x, t.y) < 380)
          .sort((p, q) => gd(c.x, c.y, p.x, p.y) - gd(c.x, c.y, q.x, q.y)).slice(0, nm - 1)
          .forEach((t) => this.proj(u, { homing: t, speed: 800, dmg: dmg * 0.5, shape, col: u.spec.fx, visual: true }));
      }
      return;
    }
    const mul = (t) => (t.structure && u.kind === 'minion' ? 1.8 : 1);
    // v0.3.0：近戰普攻只打一個目標（指定的目標，沒有就打扇形內最近的）；有擴散（趙雲橫掃千軍、方天畫戟…）才波及旁人，比例照擴散值
    const hit = this.cone(u, a.dir, u.range, 0.5), main = a.target && hit.includes(a.target) ? a.target : hit[0];
    const cleave = u.px ? u.px.cleave : 0;
    (main ? [main].concat(cleave > 0 ? hit.filter((t) => t !== main) : []) : []).forEach((t, n) => {
      const fire = tg && tg.fire && !n;
      this.damage(u, t, (dmg + (tg && !n ? tg.dmg : 0)) * (n ? cleave : 1) * mul(t), { stagger: 0.22, knock: 6, basic: !n, el: fire ? 'fire' : undefined, fire });
      if (!n) { this.onHitProcs(u, t); if (fire && t.alive) this.ignite(t, tg.dmg * 0.3, 2, u); if (tg && tg.poison) this.tgPoison(u, t, tg.poison); }
    });
  }
  // 開關技的毒：持續傷害＋緩速（同一個來源重複上毒只刷新）
  tgPoison(src, t, P) {
    if (!P || !t.alive || t.structure) return;
    if (P.dps) this.xDot(src, t, P.dps, P.dur, 'poison');
    if (P.slow) this.addBuff(t, { id: 'poison:' + src.id, t: P.dur, ms: -P.slow / 100, neg: true });
  }
  // 開關技：真人自己開關，電腦學會了就一直開著；氣不夠這發就不附加
  tgShot(u) {
    if (u.kind !== 'hero' || !u.spec.skills) return null;
    for (let i = 0; i < 4; i++) {
      const sk = u.spec.skills[i], lvl = u.skillLv[i];
      if (!sk || !sk.tg || !lvl) continue;
      if (u.manual ? !(u.tgOn && u.tgOn[i]) : false) continue;
      const cost = L(sk.tg.mp, lvl);
      if (u.mp < cost) { if (u.human && !(u.tgWarnT > this.t)) { u.tgWarnT = this.t + 3; this.tell(u, `${SG.resName(u)}不足，${sk.name} 這一發沒點火`, 'warn'); } return null; }
      u.mp -= cost;
      // 火（黃忠「火箭矢」）：附加火焰傷害並點燃；毒（張郃「毒箭」，v0.3.8）：附毒、緩速
      const P = sk.tg.poison;
      return { dmg: sk.tg.orb ? L(sk.tg.orb, lvl) : 0, fire: !!sk.tg.orb, poison: P ? { dps: L(P.dps, lvl), dur: P.dur, slow: L(P.slow, lvl) } : null, i };
    }
    return null;
  }

  // ---------- 技能 ----------
  // 耗血（技能資料 hpCost：目前生命的 %）：直接扣生命、至少留 1，不算受到傷害；扣掉的量記在 u.hpPaid 給技能本身用
  payHp(u, sk, lvl) {
    if (!sk || !sk.hpCost) return;
    const c = Math.min(u.hp - 1, u.hp * L(sk.hpCost, lvl) / 100);
    u.hpPaid = Math.max(0, c); u.hp -= u.hpPaid;
    if (u.human && u.hpPaid >= 1) this.dmgEvents.push({ x: u.x, y: u.y - 60, text: `-${L(sk.hpCost, lvl)}%`, team: u.team, src: u.id, tgt: u.id, self: 1 });
  }
  skillCost(i, lvl, sk) { return sk && sk.mp != null ? L(sk.mp, lvl) : i === 3 ? 100 + 25 * lvl : 40 + 10 * lvl; }
  skillCd(u, sk, i, lvl) {
    if (sk.cd != null) { const c = L(sk.cd, lvl); return Math.max(Math.min(1, c), c * SG.CD_SCALE) * (1 - (u.cdr || 0) / 100); } // 下限 1 秒；資料本身寫不到 1 秒的（黃蓋「傷痕」0.5）照寫的
    const b = BASE_CD[sk.arch] || 10;
    const cd = i === 3 ? Math.max(40, b * 4) - (lvl - 1) * 10 : b;
    return cd * (1 - (u.cdr || 0) / 100);
  }
  skillRange(sk, lvl) { const a = SG.aimOf(sk, lvl); return a.range ? (sk.aim ? a.range : sk.range || (sk.big ? 780 : a.range)) : 0; }
  tryCast(u, i, x, y) {
    const sk = u.spec.skills[i];
    if (!sk || sk.passive) return false;
    const lvl = u.skillLv[i];
    // 開關技（例如黃忠「火箭矢」）：切換開／關，不進冷卻、不耗氣，效果在普攻時才扣氣
    if (sk.tg) {
      if (!lvl) { this.tell(u, sk.name + ' 尚未學會', 'warn'); return false; }
      u.tgOn = u.tgOn || {}; u.tgOn[i] = !u.tgOn[i];
      this.tell(u, `${sk.name}：${u.tgOn[i] ? '開啟（每發耗 ' + L(sk.tg.mp, lvl) + ' ' + SG.resName(u) + '）' : '關閉'}`, 'info');
      if (u.tgOn[i]) this.vfx.push({ k: 'cast', x: u.x, y: u.y, el: SG.elOf ? SG.elOf(sk, u.spec.id) : null, col: u.spec.fx });
      return false;
    }
    if (!lvl || u.cd[i] > 0 || u.st.silence > 0) { this.tell(u, !lvl ? sk.name + ' 尚未學會' : u.st.silence > 0 ? '被沉默，無法施放' : sk.name + ' 冷卻中', 'warn'); return false; }
    // 可再施放的技能（同一招再放一次）：窗口內第二次不耗氣，用完才進冷卻
    const rc = u.rc && u.rc[i];
    if (rc && rc.alt && this.t < rc.until) { // 兩段式的第二段（另一招）
      const s2 = rc.alt, c2 = this.skillCost(i, lvl, s2);
      if (u.mp < c2) { this.tell(u, SG.resName(u) + '不足', 'warn'); return false; }
      u.mp -= c2; this.payHp(u, s2, lvl); u.rc[i] = null; u.cd[i] = Math.max(0, rc.cd0 - (this.t - rc.at));
      this._rcTgt = rc.tgt || null;
      const a2 = this.beginSkill(u, i, s2, lvl, x, y);
      if (s2.free) this.fireFree(u, a2); // 免動作的第二段（孫權「水球爆裂」）
      this._rcTgt = null;
      return true;
    }
    if (sk.recast && !sk.then && rc && this.t < rc.until) {
      u.rc[i] = null; u.cd[i] = this.skillCd(u, sk, i, lvl);
      const a2 = this.beginSkill(u, i, sk, lvl, x, y);
      if (sk.free) this.fireFree(u, a2); // 免動作的再施放（孫權「濡須潮界」關閉）
      return true;
    }
    const cost = this.skillCost(i, lvl, sk);
    if (u.mp < cost) { this.tell(u, SG.resName(u) + '不足', 'warn'); return false; }
    u.mp -= cost; this.payHp(u, sk, lvl); u.cd[i] = this.skillCd(u, sk, i, lvl);
    if (sk.then) { if (!sk.thenOn) this.armThen(u, i); }
    else if (sk.recast) { (u.rc || (u.rc = {}))[i] = { until: this.t + sk.recast }; u.cd[i] = 0.35; }
    const a = this.beginSkill(u, i, sk, lvl, x, y);
    if (sk.free) this.fireFree(u, a);
    if (u.st.invis > 0 && sk.arch !== 'stealth') u.st.invis = 0;
    return true;
  }
  // 免動作技：不佔用 u.act，當場跑完技能效果（at 不論多少都立刻觸發）
  fireFree(u, a) {
    const g0 = u.skG;
    this._el = SG.elOf ? SG.elOf(a.sk, u.spec && u.spec.id) : null; this._src = u.id; this._skCls = a.cls; this._xa = a; u.skG = a.g || 1;
    this.skillTick(u, a, 0, 1, 0, () => true);
    this._el = null; this._src = null; this._skCls = null; this._xa = null; u.skG = g0;
  }
  // 打開兩段式技能的第二段：recast 秒內再按同一格就放 then 那一招；tgt 是第一段標記的目標（李星 Q 打中的人）
  armThen(u, i, tgt) {
    const sk = u.spec.skills[i];
    if (!sk || !sk.then || !u.alive) return;
    (u.rc || (u.rc = {}))[i] = { until: this.t + (sk.recast || 3), alt: sk.then, tgt: tgt || null, cd0: u.cd[i], at: this.t };
    u.cd[i] = Math.min(u.cd[i], 0.35);
  }
  beginSkill(u, i, sk, lvl, x, y) {
    const a = sk.free ? { kind: 'skill', name: 's' + i, i, t: 0, dur: 1, done: {} } : this.startAct(u, 'skill', i);
    if (x === undefined) { x = u.x + u.f * 200; y = u.y; }
    a.sk = sk; a.lvl = lvl;
    a.dir = dirTo(u, x, y);
    const R = this.skillRange(sk, lvl), d = Math.min(R || 0, gd(u.x, u.y, x, y));
    a.pt = along(u.x, u.y, a.dir, d);
    a.from = [u.x, u.y];
    if (!sk.free && Math.abs(a.dir[0]) > 0.05) u.f = sign(a.dir[0]);
    // v0.3.0：基礎 ＋ 係數 × 屬性；倍率記在 u.skG，技能進行中所有 spMul 都會吃到（武將檔、通用招式一致）
    a.cls = u.kind === 'hero' && u.spec.skills ? SG.skillScale(u.spec, i) : 'fixed';
    const tot = Math.max(SG.skillTotal(sk, lvl), i === 3 ? 250 : 120), add = a.cls === 'fixed' || SG.selfScaled(sk) ? 0 : SG.SCALE_COEF[i] * SG.scaleAttr(u, a.cls);
    u.skG = a.g = (tot + add) / tot;
    a.tid = this._castTid || null; // 點擊技：點選的目標（必中）
    a.rcTgt = this._rcTgt || null; // 兩段式第二段：第一段標記的目標
    if (u.ifx && u.ifx.spellblade) u.bladeReady = true; // 太公兵法「兵法」
    a.shot = u.kind === 'hero' && SG.aimOf(sk, lvl).kind === 'dir'; // 指向技：傷害 +10%（控制 +10% 在 applyCC／proj）
    if (a.shot) u.skG = a.g = a.g * SG.SKILLSHOT_BONUS;
    a.v = parseVal(sk.desc, lvl) || (60 + 50 * lvl) * (i === 3 ? 2 : 1);
    a.dmg = a.v * SG.spMul(u) * (u.kind === 'hero' ? SG.ORIG_MUL : 1);
    if (sk.x) { a.v = L(sk.x.dmg, lvl) || L(sk.x.heal, lvl) || 0; a.dmg = a.v * SG.spMul(u); a.i = i; }
    a.rel = REL[sk.arch] || 0.8;
    // v0.3.0：小技能（Q/W/E）前搖加快 30%；大招保留原本的施法時間。會位移的、武將專屬招式照原速（距離、時間點綁在動作上）
    a.fast = u.kind === 'hero' && i < 3 && !sk.sig && !MOVE_ARCH[sk.arch] ? SG.CAST_FAST : 1;
    a.cc = ccOf(sk, lvl);
    const ult = i === 3 && !(sk.x && sk.x.k === 'form') && !sk.minor; // 形態切換（換兵）、短冷卻的 R（minor，甘寧「斬將」）不是大招，不放大招特效
    if (ult && u.kind === 'hero') this.fx({ k: 'ult', id: u.id, x: u.x, y: u.y });
    if (u.kind === 'hero') this.vfx.push({ k: 'cast', x: u.x, y: u.y, el: SG.elOf ? SG.elOf(sk, u.spec.id) : null, col: u.spec.fx, ult, src: u.id });
    if (u.grab) this.release(u);
    return a;
  }
  // 技能進行中發出的特效帶上元素，畫面層依元素換顏色、加粒子
  // _src：施法者 id，只給畫面層換造型特效用（萬聖造型），遊戲判定不讀
  fx(o) { if (this._el && o.k !== 'ult' && o.el === undefined) { o.el = this._el; if (SG.EL && o.k !== 'heal') o.col = SG.EL[this._el].col; } if (this._src != null && o.src === undefined) o.src = this._src; this.vfx.push(o); }
  skillTick(u, a, kp, k, dt, cross) {
    const sk = a.sk, lvl = a.lvl, dmg = a.dmg, dir = a.dir;
    const col = sk.col || u.spec.fx;
    if (sk.x && sk.x.k) { this.xSkill(u, a, kp, k, dt, cross); return; }
    // 武將專屬招式（技能資料的 sig，實作在武將檔的 sigSkills）
    const own = sk.sig && SIG_SKILL[sk.sig];
    if (own) { own.call(this, u, a, k, dt, cross); return; }
    const xr = sk.x || {};
    switch (sk.arch) {
      case 'multi': [0.22, 0.38, 0.56].forEach((x, j) => { if (cross(x)) this.cone(u, dir, 125, 0.55).forEach((t) => { this.damage(u, t, dmg, { stagger: 0.3, knock: j === 2 ? 34 : 8 }); if (!a.cc || !a.cc.last || j === 2) this.applyCC(u, t, a.cc); }); }); break;
      case 'spin': [0.2, 0.34, 0.48, 0.62].forEach((x, j) => { if (cross(x)) this.aoe(u, u.x, u.y, 125, dmg, { stagger: 0.3, cc: a.cc && (!a.cc.last || j === 3) ? a.cc : null }); }); break;
      case 'dash':
        if (k > 0.08 && k < 0.58) move(u, dir[0] * 300 * dt, dir[1] * 300 * dt);
        [0.14, 0.28, 0.42, 0.57].forEach((x, j) => { if (cross(x)) this.cone(u, dir, 125, 0.5).forEach((t) => { this.damage(u, t, dmg, { stagger: 0.35 }); if (a.cc && (!a.cc.last || j === 3)) this.applyCC(u, t, a.cc); }); });
        break;
      case 'charge':
        if (k > 0.15 && k < 0.6) {
          move(u, dir[0] * (xr.speed || 520) * dt, dir[1] * (xr.speed || 520) * dt);
          this.enemiesNear(u, u.x, u.y, 56).forEach((t) => {
            if (!a.done[t.id]) {
              a.done[t.id] = 1; this.damage(u, t, dmg, { stagger: 0.5 }); this.applyCC(u, t, a.cc);
            }
            if (!t.structure && t.kind !== 'boss' && t.kind !== 'cart' && !t.thrown) move(t, dir[0] * 520 * dt, dir[1] * 520 * dt);
          });
          if (sk.pal && SG.rand() < dt * 6) { this.zone(u, { x: u.x, y: u.y, r: 50, t: 2.5, tick: 0.5, dmg: dmg * 0.12, ground: true, fire: true }); }
        }
        if (cross(0.6)) this.fx({ k: 'spark', x: u.x + dir[0] * 30, y: u.y + dir[1] * 30 * K, col });
        break;
      case 'blink':
        if (cross(0.36)) {
          const p = landing(u.x, u.y, a.pt[0], a.pt[1]);
          this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = p[0]; u.y = p[1]; this.fx({ k: 'puff', x: u.x, y: u.y });
          if (parseVal(sk.desc, lvl)) this.aoe(u, u.x, u.y, 110, dmg, { stagger: 0.4, cc: a.cc });
        }
        break;
      case 'slam': {
        if (!a.land) a.land = landing(a.from[0], a.from[1], a.pt[0], a.pt[1]);
        if (k > 0.22 && k < 0.55) { const q = (k - 0.22) / 0.33; u.x = a.from[0] + (a.land[0] - a.from[0]) * q; u.y = a.from[1] + (a.land[1] - a.from[1]) * q; u.air = true; }
        if (cross(0.55)) {
          u.x = a.land[0]; u.y = a.land[1]; u.air = false;
          // 原型的選項：sig 'siege' 打城寨附近加倍（呂蒙「奪取荊州」）
          const siege = sk.sig === 'siege' && this.units.some((o) => o.structure && o.alive && o.team !== u.team && gd(o.x, o.y, u.x, u.y) < 600);
          this.aoe(u, u.x, u.y, xr.r || 145, dmg * (siege ? 2 : 1), { ground: true, cc: sk.x ? a.cc : a.cc || { stun: 0.6 }, falloff: xr.falloff ? [u.x, u.y, xr.r || 145] : null, spell: !!sk.x });
          this.fx({ k: 'slam', x: u.x, y: u.y, col });
        }
        break;
      }
      case 'crescent':
        if (cross(0.4)) { this.proj(u, { dir, speed: 470, range: 460, dmg, pierce: true, rad: 40, visual: false, cc: a.cc }); this.fx({ k: 'crescent', x: u.x + dir[0] * 30, y: u.y + dir[1] * 30 * K, vx: dir[0] * 470, vy: dir[1] * 470 * K, f: sign(dir[0]) || u.f, col }); }
        break;
      case 'bolt': {
        const n = sk.n || 1;
        for (let j = 0; j < n; j++) if (cross(0.42 + j * (0.3 / n))) {
          const spread = n > 1 ? (j - (n - 1) / 2) * 0.14 : 0, c = Math.cos(spread), s = Math.sin(spread);
          const d2 = [dir[0] * c - dir[1] * s, dir[0] * s + dir[1] * c];
          this.proj(u, { dir: d2, speed: sk.range ? 900 : 580, range: this.skillRange(sk, lvl), dmg, pierce: !!sk.big, rad: sk.big ? 20 : 14,
            shape: sk.shape || (u.spec.ranged ? SG.rangedShape(u.spec) : 'orb'), col, visual: true, big: sk.big,
            slow: sk.shape === 'ice' ? [0.35, 1.2] : null, burn: sk.shape === 'fire', cc: a.cc });
        }
        break;
      }
      case 'hook': if (cross(0.4)) this.proj(u, { dir, speed: sk.aim ? 1400 : 1000, range: sk.aim ? this.skillRange(sk, lvl) : 330, dmg: dmg * 0.6, hook: true, rad: 18, visual: true, col, cc: a.cc }); break;
      case 'fire': [95, 150, 205, 260].forEach((d, j) => {
        if (!cross(0.56 + j * 0.06)) return;
        const p = along(u.x, u.y, dir, d);
        // 原型的選項：sig 'chainfire' 火勢延燒（周瑜「火燒連環」）
        this.aoe(u, p[0], p[1], 56, dmg, { ground: true, stagger: 0.3, pal: sk.pal || 'fire', cc: a.cc, chain: sk.sig === 'chainfire' });
        this.fx({ k: 'fire', x: p[0], y: p[1], pal: sk.pal });
      }); break;
      case 'spikes': for (let j = 0; j < 6; j++) if (cross(0.4 + (j * 0.07) / a.dur)) {
        const p = along(u.x, u.y, dir, 48 + 34 * j);
        this.aoe(u, p[0], p[1], 32, dmg, { ground: true, stagger: 0.3, once: a, pal: sk.pal, cc: a.cc });
        this.fx({ k: 'spike', x: p[0], y: p[1], pal: sk.pal, col, h: 36 + j * 4 });
      } break;
      case 'volley':
        if (cross(0.5)) {
          const rain = (x, y) => { this.zone(u, { x, y, r: 84, t: 1.5, tick: 0.35, dmg: dmg * 0.35, slow: 0.3, cc: a.cc }); this.fx({ k: 'rain', x, y, col }); };
          rain(a.pt[0], a.pt[1]);
        }
        break;
      case 'thunder':
        if (cross(0.5)) {
          const px = a.pt[0], py = a.pt[1], cc = a.cc || { stun: 0.8 };
          const strike = () => { this.aoe(u, px, py, 92, dmg, { cc }); this.fx({ k: 'thunder', x: px, y: py, col }); };
          strike();
        }
        break;
      case 'roar':
        if (cross(0.44)) this.cone(u, dir, 300, 0.64).forEach((t) => {
          if (t.structure || t.kind === 'boss' || t.kind === 'cart') return;
          const cc = Object.assign({}, a.cc || { fear: 1.2 + lvl * 0.3 });
          this.applyCC(u, t, cc);
        });
        break;
      case 'heal': if (cross(0.35)) { this.alliesNear(u, 330).forEach((t) => this.heal(t, a.v)); this.fx({ k: 'heal', x: u.x, y: u.y, col }); } break;
      case 'shield':
        if (cross(0.2)) {
          const amt = parseVal(sk.desc, lvl) || 120 + 60 * lvl;
          u.st.shield = amt; u.st.shieldT = 3;
          const ally = this.alliesNear(u, 300).find((t) => t !== u && t.kind === 'hero');
          if (ally) { ally.st.shield = amt * 0.6; ally.st.shieldT = 3; }
          if (a.cc) this.enemiesNear(u, u.x, u.y, 260).forEach((t) => this.applyCC(u, t, a.cc));
        }
        break;
      case 'buff':
        if (cross(0.3)) { u.st.atkUp = 5; u.st.atkUpAmt = 0.2 + 0.05 * lvl; u.st.dr = 5; u.st.drAmt = 0.15; this.heal(u, (u.maxHp - u.hp) * 0.1); } break;
      case 'command':
        if (cross(0.3)) {
          this.alliesNear(u, 540).forEach((t) => { t.st.atkUp = 6; t.st.atkUpAmt = 0.12 + 0.05 * lvl; t.st.msUp = 6; t.st.msUpAmt = 0.08; });
          if (sk.glyph === '風') this.startWind(8 + 2 * lvl);
          if (a.cc) this.enemiesNear(u, u.x, u.y, 420).forEach((t) => { if (t.kind === 'hero') this.applyCC(u, t, a.cc); });
        }
        break;
      case 'summon':
        if (cross(0.4)) for (let j = 0; j < 3; j++) {
          const p = landing(u.x, u.y, a.pt[0] + (j - 1) * 30, a.pt[1] + (j - 1) * 20);
          const s = this.spawnMinion(u.team, null, p[0], p[1], j === 1);
          s.temp = 12; s.atk *= 1 + 0.25 * lvl; s.maxHp *= 1 + 0.3 * lvl; s.hp = s.maxHp; s.owner = u;
        }
        break;
      case 'trap':
        if (cross(0.4)) {
          const dot = sk.shape === 'fire' || sk.shape === 'poison' || sk.shape === 'ice';
          const zc = a.cc && !a.cc.root ? a.cc : null;
          this.zone(u, { x: a.pt[0], y: a.pt[1], r: dot ? 90 : 70, t: dot ? 4 : 6, tick: 0.5, dmg: dot ? dmg * 0.25 : 0, root: dot || zc ? 0 : (a.cc && a.cc.root) || 1.2, cc: zc, ground: true, slow: sk.shape === 'ice' ? 0.4 : 0, fire: sk.shape === 'fire', pal: sk.shape });
        }
        break;
      case 'stealth': if (cross(0.28)) { u.st.invis = sk.dur ? L(sk.dur, lvl) : 3 + lvl * 0.5; this.fx({ k: 'puff', x: u.x, y: u.y }); } break; // sk.dur：說明寫的秒數（黃蓋「詐降」）
    }
  }

  // ---------- 判定 ----------
  // untargetable（無法被選取，郭脩「死亡印記」途中）：選不到、範圍技打不到、不受傷害與控制
  isEnemy(u, t) { return t.alive && !t.untargetable && t.team !== u.team && t.kind !== 'ward' && (t.kind !== 'seal' || u.kind === 'hero') && !(t.team < 2 && u.team < 2 && !t.vis[u.team]); }
  // 扇形：地面度量距離 ≤ range，且方向夾角餘弦 ≥ cos（貼身的一律算中）
  cone(u, dir, range, cos) {
    const out = [];
    for (const t of this.units) {
      if (!this.hostile(u, t)) continue;
      const gx = t.x - u.x, gy = (t.y - u.y) / K, d = Math.hypot(gx, gy);
      if (d - t.r > range) continue;
      if (d > t.r + 10 && (gx * dir[0] + gy * dir[1]) / d < cos) continue;
      out.push([d, t]);
    }
    return out.sort((a, b) => a[0] - b[0]).map((p) => p[1]);
  }
  // 範圍與投射物的命中不看視野：朝戰爭迷霧裡放技能一樣打得到
  hostile(u, t) { return t.alive && !t.untargetable && t.team !== u.team && t.kind !== 'ward' && (t.kind !== 'seal' || (u.owner || u).kind === 'hero'); } // 玉璽只有武將打得到
  enemiesNear(u, x, y, r) { return this.units.filter((t) => this.hostile(u, t) && gd(x, y, t.x, t.y) <= r + t.r * 0.5); }
  alliesNear(u, r) { return this.units.filter((t) => t.alive && t.team === u.team && !t.structure && t.kind !== 'ward' && gd(u.x, u.y, t.x, t.y) <= r); }
  aoe(u, x, y, r, dmg, o) {
    this.enemiesNear(u, x, y, r).forEach((t) => {
      if (o.ground && t.air) return;
      if (o.once) { if (o.once.done[t.id]) return; o.once.done[t.id] = 1; }
      this.damage(u, t, o.falloff ? dmg * (1 - 0.6 * Math.min(1, gd(o.falloff[0], o.falloff[1], t.x, t.y) / o.falloff[2])) : dmg, o);
      if (o.cc) this.applyCC(u, t, o.cc);
      if (o.pal === 'ice') { t.st.slow = 1.2; t.st.slowAmt = 0.4; }
      if ((o.pal === 'poison' || o.pal === 'fire') && this.ignite(t, dmg * 0.08, 2, u, o.pal === 'fire')) t.st.chainFire = !!o.chain;
    });
  }
  // 燃燒／中毒共用一格：保留每秒傷害較高的那一個，時間取較長的（v0.4.2，之前後上的直接蓋掉、較弱的會把較強的換掉）
  ignite(t, dps, dur, src, fire = true) {
    const s = t.st;
    if (s.burn > 0 && s.burnSrc && s.burnDps > dps) { s.burn = Math.max(s.burn, dur); return false; }
    s.burn = Math.max(s.burn > 0 ? s.burn : 0, dur); s.burnDps = dps; s.burnSrc = src; s.burnFire = fire;
    return true;
  }
  heal(t, v) { if (!t.alive) return; if (t.ign) v *= 0.6; /* 毒害：治療 -40% */ const h = Math.min(v, t.maxHp - t.hp); t.hp += h; if (h > 5 && t.human) this.dmgEvents.push({ x: t.x, y: t.y, v: h, heal: true, team: t.team, tgt: t.id }); }

  damage(src, t, amount, o) {
    o = o || {};
    // sk：這一下來自技能（v0.3.8 審查）。舊式招式（衝鋒、雷擊、彈道…）不會帶 spell，被動「被技能打中」「技能傷害 +X%」要認這個
    if (!o.sk && !o.basic && (o.spell || this._xa)) o = Object.assign({}, o, { sk: true });
    if (t.kind === 'seal') return this.sealHit(src, t, o); // 玉璽：專用規則（v0.3.0）
    if (!t.alive || (t.team === src.team && !o.deny)) return;
    if (t.invuln || t.untargetable || (t.structure && this.structureLocked(t))) return;
    if ((t.px || t.bf) && this.xPreDamage(src, t, o) === false) return;
    let a = amount;
    if (src.siege) a *= t.structure ? src.bldMul || 1 : src.siege === 'catapult' && t.kind === 'minion' ? 0.5 : 1;
    const fire = o.fire || o.pal === 'fire';
    if (fire && this.wind.on > 0) a *= 1.5;
    // 追擊：打隊友控住的敵人 +15%，打在空中的 +30%
    const own0 = src.owner || src;
    // 攻擊會暴露自己：躲在蘆葦或視野外打人，被打的一方看得到攻擊者 2 秒（隱身技能自己處理，不在這裡破隱）
    if (own0.kind === 'hero' && own0.alive && t.team < 2 && own0.team !== t.team && !(own0.st.invis > 0) && !((own0.exposed && own0.exposed[t.team]) > this.t + 1.5)) this.expose(own0, t.team, 2);
    if (own0.kind === 'hero' && t.st.ccBy && t.st.ccBy !== own0 && t.st.ccBy.team === own0.team && this.hardCC(t)) {
      a *= t.st.knockup > 0 ? 1.3 : 1.15;
      if (own0.stat && (!t.chaseT || this.t - t.chaseT > 1)) own0.stat.chase++;
      if (own0.human && (!t.chaseT || this.t - t.chaseT > 1)) { t.chaseT = this.t; this.dmgEvents.push({ x: t.x, y: t.y - 60, text: t.st.knockup > 0 ? '空中追擊' : '追擊', team: t.team, src: own0.id }); }
    }
    // v0.3.0：物理吃物防（扣物穿）、法術吃法防（扣法穿）；破甲讓物防暫時 ×0.7
    // 技能進行中的直接傷害：吃智力→法術、吃武力／敏捷→物理；固定的照技能原本設定
    if (this._skCls && this._skCls !== 'fixed' && !o.quiet) o = Object.assign({}, o, { magic: this._skCls === 'int' });
    const pen = src.owner || src;
    if (pen.st && pen.st.weak > 0) a *= 0.65; // 被「拖延」：造成的傷害 -35%
    if (pen.spec && pen.spec.dmgMul) a *= pen.spec.dmgMul; // 武將整體傷害倍率（SG.TUNE）
    if (pen.ifx && pen.ifx.execute && t.kind === 'hero' && t.hp / t.maxHp < pen.ifx.execute.below) a *= 1 + pen.ifx.execute.amp; // 青龍偃月刀「斬將」
    if (o.pure) { /* 真實傷害（謀略）：不吃物防、法防、防禦 */ } else if (!o.magic) {
      const arm = Math.max(0, this.xArmor(t) * (t.st.shred > 0 ? 0.7 : 1) - (pen.apen || 0)), mul = (A) => 100 / (100 + A * 6);
      // 防禦（v0.3.8）：按住時物防 ×1.2 再 +8（算在物穿之後，物穿吃不掉），只擋物理、不分方向；控制、硬直照吃。擋下的量記進「累計抵禦傷害」
      // v0.4.2：擋下的量 ×2；u.blockN 累計擋下的次數（郝昭「重門」）
      if (t.defending) {
        const full = a * mul(arm), blk = Math.min(full, (full - a * mul(arm * SG.DEFEND_ARMOR[0] + SG.DEFEND_ARMOR[1])) * SG.DEFEND_BLOCK_MUL + full * (t.blockAdd || 0)); // blockAdd：郝昭「重門」多擋的比例
        a = full - blk; if (t.stat) t.stat.blocked += blk;
        if (blk > 0) t.blockN = (t.blockN || 0) + 1;
      }
      else a *= mul(arm);
    } else a *= 100 / (100 + Math.max(0, (t.mr || 0) - (pen.mpen || 0)) * 6);
    if (t.st.dr > 0) a *= 1 - t.st.drAmt;
    if (t.bf && t.bf.taken) a *= 1 + t.bf.taken;
    if (o.spell && t.px && t.px.resist) a *= 1 - t.px.resist;
    // 小兵（含軍令部隊）打武將只有 55% 傷害（2026-10-02：小兵太強）；技能召喚物照原版數值，不打折
    if (t.kind === 'hero' && (src.owner || src).kind === 'minion' && !(src.owner || src).summon) a *= 0.55;
    if (this.react) a = this.react(src, t, a, o); // 元素反應（elements.js）
    if (this.itemTaken) a = this.itemTaken(src, t, a, o); // 裝備的受傷效果（itemfx.js）
    if (t.st.shield > 0) { const s = Math.min(t.st.shield, a); t.st.shield -= s; a -= s; }
    const real = Math.min(a, Math.max(0, t.hp)); // 不把溢出的傷害算進戰績
    t.hp -= a;
    const sh = src.owner || src;
    if (sh.stat) { if (t.kind === 'hero') sh.stat.dmgHero += real; else if (t.structure) sh.stat.dmgBld += real; }
    if (t.stat) t.stat.taken += real;
    this.xPost(src, t, a, o);
    if (t.recall && real > 0 && (sh.kind === 'hero' || sh.structure)) this.cancelRecall(t, '回城被打斷');
    if (src.kind === 'hero') { t.dmgBy[src.id] = this.t; if (t.kind === 'hero') { src.aggroT = this.t; src.aggroOn = t; } }
    if (t.kind === 'creep' || t.kind === 'boss') t.aggro = src.owner || src;
    const own = src.owner || src;
    if (!o.quiet && (own.human || t.human)) this.dmgEvents.push({ x: t.x, y: t.y, v: a, team: t.team, src: own.id, tgt: t.id, el: o.el !== undefined ? o.el : o.basic ? null : this._el || null });
    if (!t.structure && t.kind !== 'boss' && t.kind !== 'cart') {
      if (o.stun) { t.st.stun = Math.max(t.st.stun, o.stun); if (t.grab) this.release(t); }
      // 武將只會被武將打出硬直；小兵、黃巾賊、城寨的普攻不會打斷武將（不然幾隻小兵就能把人卡住）
      const armored = (t.act && t.act.kind === 'skill') || t.st.knockup > 0 || t.st.down > 0 || (t.kind === 'hero' && (src.owner || src).kind !== 'hero');
      if (o.stagger && !armored) { t.stagger = Math.max(t.stagger, o.stagger); t.act = null; t.air = false; t.noPx = false; t.anim = 'hit'; t.animSeq++; }
      if (o.knock) { const d = dirTo(src, t.x, t.y); move(t, d[0] * o.knock, d[1] * o.knock); }
    }
    if (t.hp <= 0) this.kill(src.owner || src, t);
  }
  structureLocked(t) {
    // 城寨由外往內拆；兵營要先拆掉該路所有城寨；糧倉要先拆掉該路第一座城寨；本營要先拆掉任一路最內層的城寨
    if (t.kind === 'tower') return this.units.some((o) => o.kind === 'tower' && o.alive && o.team === t.team && o.lane === t.lane && o.tier < t.tier);
    if (t.kind === 'barracks') return this.units.some((o) => o.kind === 'tower' && o.alive && o.team === t.team && o.lane === t.lane);
    if (t.kind === 'granary') return this.units.some((o) => o.kind === 'tower' && o.alive && o.team === t.team && o.lane === t.lane && o.tier === 1);
    if (t.kind === 'base') return !this.units.some((o) => o.kind === 'tower' && !o.alive && o.team === t.team && o.inner);
    return false;
  }

  // ---------- 投射物與區域 ----------
  proj(u, o) {
    if (this._skShot === u && o.cc) o = Object.assign({}, o, { cc: SG.scaleCC(o.cc, SG.SKILLSHOT_BONUS) }); // 指向技射出的：控制 +10%
    const dir = o.dir || [u.f, 0];
    if (this.wind.on > 0 && !o.homing && dir[0] < -0.2) o = Object.assign({}, o, { speed: o.speed * 1.25, range: (o.range || 400) * 1.2 }); // 順風
    const start = along(u.x, u.y, dir, 30);
    if (o.el === undefined) o = Object.assign({}, o, { el: this._el || null });
    this.projs.push(Object.assign({ fromSk: !!this._xa && !o.basic, team: u.team, owner: u, x: start[0], y: start[1], vx: dir[0] * o.speed, vy: dir[1] * o.speed * K, f: sign(dir[0]) || u.f, dist: 0, rad: 14, hit: {}, t: 0 }, o));
  }
  updateProjs(dt) {
    this.projs = this.projs.filter((p) => {
      p.t += dt; this._el = p.el || null; this._src = p.owner ? p.owner.id : null;
      if (p.homing) {
        const t = p.homing;
        if (!t.alive) return false;
        const ty = t.y - (p.tower ? 40 : 0);
        const dx = t.x - p.x, dy = ty - p.y, d = Math.hypot(dx, dy), s = p.speed * dt;
        p.f = sign(dx) || p.f; p.ang = Math.atan2(dy, dx); p.vx = (dx / (d || 1)) * p.speed; p.vy = (dy / (d || 1)) * p.speed;
        if (d <= s + 10) {
          if (p.onHit) { p.onHit(t); return false; }
          this.damage(p.owner, t, p.dmg, { stagger: p.tower ? 0 : 0.12, deny: p.deny, basic: p.basic, el: p.burn ? 'fire' : undefined, fire: !!p.burn, sk: p.fromSk });
          if (p.basic) this.onHitProcs(p.owner, t);
          if (p.burn && t.alive && !t.structure) this.ignite(t, p.dmg * 0.1, 2, p.owner);
          if (p.poison) this.tgPoison(p.owner, t, p.poison);
          return false;
        }
        p.x += (dx / d) * s; p.y += (dy / d) * s;
        return true;
      }
      p.x += p.vx * dt; p.y += p.vy * dt; p.dist += p.speed * dt;
      for (const t of this.units) {
        if (!this.hostile(p.owner, t) || p.hit[t.id] || (t.kind === 'seal' && !p.basic)) continue; // 技能投射物穿過玉璽
        if (gd(p.x, p.y, t.x, t.y) > t.r + p.rad) continue;
        p.hit[t.id] = 1;
        if (p.hook) {
          if (p.cc && (p.cc.charm || p.cc.confuse || p.cc.silence)) { this.damage(p.owner, t, p.dmg, {}); this.applyCC(p.owner, t, p.cc); return false; }
          if (!t.structure && t.kind !== 'boss' && t.kind !== 'cart') {
            const o = p.owner, dir = dirTo(o, t.x, t.y), q = landing(o.x, o.y, ...along(o.x, o.y, dir, 70));
            t.x = q[0]; t.y = q[1]; t.st.stun = Math.max(t.st.stun, 0.6);
          }
          this.damage(p.owner, t, p.dmg, {});
          return false;
        }
        let pd = p.dmg;
        this.damage(p.owner, t, pd, { stagger: p.pierce ? 0.25 : 0.15, fire: p.burn, spell: p.spell, magic: p.spell, sk: p.fromSk });
        if (p.cc) this.applyCC(p.owner, t, p.cc);
        if (p.slow) { t.st.slow = p.slow[1]; t.st.slowAmt = p.slow[0]; }
        if (p.stun) t.st.stun = Math.max(t.st.stun, p.stun);
        if (p.burn) this.ignite(t, p.dmg * 0.1, 2, p.owner);
        if (p.poison) this.tgPoison(p.owner, t, p.poison);
        if (!p.pierce) return false;
      }
      if (p.dist >= p.range) return false;
      // 樹林會擋下非貫穿的投射物（可以躲在樹後）；江面不擋
      return p.pierce || M.walkable(p.x, p.y);
    });
  }
  zone(u, o) { this.zones.push(Object.assign({ team: u.team, owner: u, next: 0, hitOnce: {}, el: this._el || null }, o)); }
  updateZones(dt) {
    this.zones = this.zones.filter((z) => {
      z.t -= dt; z.next -= dt; this._el = z.el || null; this._src = z.owner ? z.owner.id : null;
      if (z.x2 && this.xZone(z, dt) === false) return false;
      if (z.next <= 0) {
        z.next = z.tick || 0.5;
        this.enemiesNear(z.owner, z.x, z.y, z.r).forEach((t) => {
          if (z.ground && t.air) return;
          if (z.dmg) this.damage(z.owner, t, z.dmg, { magic: true, quiet: true, spell: true, fire: z.fire || z.pal === 'fire' });
          if ((z.root || z.cc) && !z.hitOnce[t.id]) { z.hitOnce[t.id] = 1; this.applyCC(z.owner, t, z.cc || { root: z.root }); }
          if (z.slow) { t.st.slow = 0.6; t.st.slowAmt = z.slow; }
        });
      }
      return z.t > 0;
    });
  }

  // ---------- 兵線、黃巾賊、城寨 ----------
  spawnWaves(dt) {
    this.waveT -= dt;
    if (this.waveT > 0) return;
    this.waveT = this.tune.wave; this.wave++;
    if (this.wave === 1) this.say('兩軍出兵！', 'big');
    const n = this.t > 8 * 60 ? 6 : 4; // 8 分鐘後每波多一名槍兵、一名弓手
    for (const lane of this.lanes) for (let team = 0; team < 2; team++) {
      // 兵營被毀，該路不再出兵
      if (this.units.some((o) => o.kind === 'barracks' && o.team === team && o.lane === lane && !o.alive)) continue;
      const path = M.laneFor(lane, team);
      const bl = Math.hypot(path[1][0] - path[0][0], path[1][1] - path[0][1]), bx = (path[1][0] - path[0][0]) / bl, by = (path[1][1] - path[0][1]) / bl;
      for (let j = 0; j < n; j++) {
        const m = this.spawnMinion(team, lane, path[0][0] - bx * j * 50 - by * ((j % 2) - 0.5) * 30, path[0][1] - by * j * 50 + bx * ((j % 2) - 0.5) * 30, j === 3 || j === 5);
        m.path = path; m.wp = 1;
        if (this.supply[team] > 0) { m.maxHp *= 1.25; m.hp = m.maxHp; m.atk *= 1.25; m.fed = true; }
      }
    }
    for (let team = 0; team < 2; team++) if (this.supply[team] > 0) this.supply[team]--;
  }
  spawnMinion(team, lane, x, y, archer) {
    const fac = team === 1 ? 'wei' : SG.rand() < 0.5 ? 'shu' : 'wu';
    const spec = archer ? SG.ARCHERS[fac] : SG.SOLDIERS[fac];
    const g = 1 + this.wave * 0.04;
    const m = unit({ kind: 'minion', spec, team, lane, x, y, f: team ? -1 : 1, r: 18, name: spec.name, ranged: archer,
      hp: (archer ? 300 : 430) * g, maxHp: (archer ? 300 : 430) * g, atk: (archer ? 22 : 18) * g, armor: 2, asp: 100, ms: 250, range: archer ? 380 : 70, think: SG.rand() * 0.3 });
    this.units.push(m);
    return m;
  }
  campTick(dt) {
    for (const cs of this.camps) {
      if (cs.units.some((u) => u.alive)) continue;
      cs.t -= dt;
      if (cs.t > 0) continue;
      cs.t = 60;
      const c = cs.c, list = c.kind === 'bandit' ? [['bandit', 0, 0, 1100, 40], ['huangjin', -60, 30, 450, 22], ['huangjin', 60, -30, 450, 22]]
        : [['huangjin', 0, 0, 520, 26], ['huangjin', -60, 30, 520, 26], ['huangjin', 60, -30, 520, 26]];
      cs.units = list.map(([k, dx, dy, hp, atk]) => {
        const u = unit({ kind: 'creep', spec: SG.NEUTRAL[k], team: 2, x: c.x + dx, y: c.y + dy, home: [c.x + dx, c.y + dy], f: c.side ? 1 : -1, r: k === 'bandit' ? 26 : 20,
          hp, maxHp: hp, atk, armor: 3, asp: 100, ms: 260, range: 70, gold: k === 'bandit' ? 90 : 45, xp: k === 'bandit' ? 110 : 60, name: SG.NEUTRAL[k].name, think: 0 });
        this.units.push(u);
        return u;
      });
    }
  }
  bossTick(dt) {
    // 飛將之威：到期前每一步替活著的隊員補上（復活的人自然接上）
    const L = this.lubu;
    if (L) for (let T = 0; T < 2; T++) if (L[T] > this.t) {
      const B = SG.LUBU_BUFF;
      for (const h of this.heroes(T)) if (h.alive && !(h.buffs && h.buffs.some((b) => b.id === 'lubu' && b.t > 0.2))) this.addBuff(h, { id: 'lubu', t: Math.min(1, L[T] - this.t), atkP: B.atkP, as: B.as, ms: B.ms, taken: B.taken });
    }
    if (this.boss && this.boss.alive) return;
    this.bossT -= dt;
    if (this.bossT > 0) return;
    this.bossT = 180;
    const b = M.boss;
    this.boss = unit({ kind: 'boss', spec: SG.LUBU, team: 2, x: b.x, y: b.y, home: [b.x, b.y], f: -1, r: 34, hp: 7000, maxHp: 7000, atk: 140, armor: 8, asp: 100, ms: 280, range: 120,
      name: '呂布', skillLv: [1, 1, 1, 1], cd: [4, 6, 8, 12], gold: 600, xp: 400, think: 0 });
    this.units.push(this.boss);
    this.say('呂布出現在江心島！', 'big');
  }
  // 小兵、黃巾賊、首領：只負責下指令，執行交給 control()
  creepAI(u, dt) {
    const I = u.input;
    if (u.grabbedBy || u.thrown) return;
    if (u.temp !== undefined) { u.temp -= dt; if (u.temp <= 0) { u.alive = false; u.deadT = this.t; return; } }
    u.think -= dt;
    if (u.think <= 0) { u.think = 0.3; u.target = this.pickTarget(u); }
    const neutral = u.team === 2;
    if (neutral && gd(u.x, u.y, u.home[0], u.home[1]) > 560) { u.aggro = null; u.target = null; u.hp = Math.min(u.maxHp, u.hp + u.maxHp * 0.2 * dt); }
    const t = u.target;
    I.moveTo = null; I.target = null;
    if (t && t.alive) {
      if ((u.kind === 'boss' || u.caster) && !u.act && this.inRange(u, t)) for (let i = 0; i < 4; i++) if (u.cd[i] <= 0 && SG.rand() < 0.3) {
        u.cd[i] = [7, 9, 11, 16][i];
        this.beginSkill(u, i, u.spec.skills[i], 1, t.x, t.y).dmg = parseVal(u.spec.skills[i].desc, 1);
        return;
      }
      I.target = t;
      return;
    }
    if (u.kind === 'minion' && u.path) {
      const wp = u.path[Math.min(u.wp, u.path.length - 1)];
      if (Math.hypot(wp[0] - u.x, wp[1] - u.y) < 60 && u.wp < u.path.length - 1) u.wp++;
      I.moveTo = wp;
    } else if (u.home) { if (gd(u.x, u.y, u.home[0], u.home[1]) > 12) I.moveTo = u.home; }
    else if (u.owner && u.owner.alive && gd(u.x, u.y, u.owner.x, u.owner.y) > 90) I.moveTo = along(u.owner.x, u.owner.y, [-u.owner.f, 0], 60);
  }
  pickTarget(u) {
    if (u.team === 2) return u.aggro && u.aggro.alive && gd(u.aggro.x, u.aggro.y, u.home[0], u.home[1]) < 600 ? u.aggro : null;
    let best = null, bs = 1e9;
    for (const t of this.units) {
      if (!this.isEnemy(u, t) || t.team === 2) continue;
      if (u.siege === 'ram' && !t.structure) continue;
      if (u.siege && t.structure && this.structureLocked(t)) continue;
      const d = gd(u.x, u.y, t.x, t.y);
      if (d > Math.max(400, u.range) + t.r) continue;
      const score = (u.siege && t.structure ? -500 : 0) + d + (t.kind === 'minion' ? 0 : t.structure ? 150 : t.aggroT > this.t - 2 ? -100 : 260);
      if (score < bs) { bs = score; best = t; }
    }
    return best;
  }
  // 箭塔／本營：有敵將在塔下打我方武將，立刻轉火他；連續打同一名武將傷害逐發疊加（最多 2.5 倍）
  towerAI(u, dt) {
    const inR = (t) => t.alive && gd(u.x, u.y, t.x, t.y) <= u.range;
    const aggro = this.units.find((h) => h.kind === 'hero' && this.isEnemy(u, h) && h.aggroT > this.t - 2 && inR(h) && h.aggroOn && gd(u.x, u.y, h.aggroOn.x, h.aggroOn.y) <= u.range + 150);
    if (aggro && aggro !== u.target) { u.target = aggro; u.ramp = 1; u.atkCd = Math.min(u.atkCd, 0.15); if (aggro.human) this.tell(aggro, '你越塔攻擊，城寨鎖定了你！', 'warn'); }
    if (u.atkCd > 0) return;
    let t = u.target && this.isEnemy(u, u.target) && inR(u.target) ? u.target : null;
    if (!t) {
      let bd = 1e9;
      for (const o of this.units) {
        if (!this.isEnemy(u, o) || !inR(o) || o.team === 2) continue;
        const d = gd(u.x, u.y, o.x, o.y) + (o.kind === 'hero' ? 400 : 0);
        if (d < bd) { bd = d; t = o; }
      }
    }
    if (t !== u.target) u.ramp = 1;
    u.target = t;
    if (!t) return;
    u.atkCd = u.rate || 1.1;
    let dmg = u.atk;
    if (t.kind === 'hero') { dmg *= u.ramp || 1; u.ramp = Math.min(2.5, (u.ramp || 1) + 0.35); }
    else if (t.kind === 'minion') dmg *= u.kind === 'base' ? 1 : 1.6;
    this.projs.push({ team: u.team, owner: u, x: u.x, y: u.y - (u.kind === 'base' ? 180 : 120), f: sign(t.x - u.x) || 1, speed: 1000, dmg, homing: t, t: 0, visual: true, shape: 'arrow', tower: true, rad: 10, hit: {} });
  }
  separate() {
    const list = this.units.filter((u) => u.alive && (u.kind === 'minion' || u.kind === 'creep'));
    for (let i = 0; i < list.length; i++) for (let j = i + 1; j < list.length; j++) {
      const a = list[i], b = list[j];
      if (a.team !== b.team) continue;
      const dx = b.x - a.x, dy = (b.y - a.y) / K, d = Math.hypot(dx, dy), min = a.r + b.r;
      if (d < min && d > 0.01) { const p = (min - d) * 0.25; move(a, (-dx / d) * p, (-dy / d) * p); move(b, (dx / d) * p, (dy / d) * p); }
    }
  }

  // ---------- 擊殺與成長 ----------
  // 陣亡畫面用的擊殺者快照：當下的等級、生命、裝備、技能等級，加上 10 秒內出過手的其他敵將（純資料，連線時直接送給被殺的人）
  deathInfo(src, t) {
    const k = src.owner && src.owner.kind === 'hero' ? src.owner : src;
    const o = { kind: k.kind, name: k.kind === 'tower' || k.kind === 'base' ? '城寨' : k.kind === 'minion' ? '小兵' : k.name || '', team: k.team };
    if (k.kind === 'hero') Object.assign(o, { id: k.id, sp: k.spec ? k.spec.id : null, lv: k.lv, hp: Math.ceil(k.hp), mh: Math.round(k.maxHp), it: k.items.map((i) => (i ? i.id : 0)), sl: k.skillLv.slice() });
    o.help = this.heroes(1 - t.team).filter((h) => h !== k && t.dmgBy[h.id] > this.t - 10).map((h) => h.name);
    return o;
  }
  kill(src, t) {
    if (!t.alive) return;
    if (this.xPreKill(src, t)) return;
    t.alive = false; t.deadT = this.t; t.act = null; t.anim = 'fall'; t.animSeq++; t.st = mkStatus(); t.input = {};
    t.lastKiller = src; // 玉璽繼承用
    if (t.kind === 'hero') t.deathBy = this.deathInfo(src, t); // 陣亡畫面顯示擊殺者（v0.3.8）
    if (t.grabbedBy) this.release(t.grabbedBy);
    if (t.grab) this.release(t);
    t.thrown = null;
    const killerHero = src.kind === 'hero' ? src : null;
    // 木頭：殺小兵 1、黃巾賊 2、武將 5，用來叫兵
    if (killerHero && src.team !== t.team && !t.summon) killerHero.wood = (killerHero.wood || 0) + (t.kind === 'hero' ? 5 : t.kind === 'creep' || t.kind === 'boss' ? 2 : t.kind === 'minion' ? 1 : 0);
    const near = (team, r) => this.heroes(team).filter((h) => h.alive && gd(h.x, h.y, t.x, t.y) < r);
    if (t.kind === 'minion' && t.summon) { /* 召喚物、分身不給金錢與經驗 */ } else if (t.kind === 'minion') {
      const denied = src.team === t.team;
      if (killerHero && !denied) {
        const g = (t.ranged ? 38 : 28) + (t.elite ? 20 : 0) + this.wave;
        killerHero.gold += g; killerHero.lastHits = (killerHero.lastHits || 0) + 1;
        if (killerHero.human) this.dmgEvents.push({ x: t.x, y: t.y - 30, text: `+${g} 金`, gold: 1, team: t.team, src: killerHero.id });
      }
      if (denied) { if (src.human) this.dmgEvents.push({ x: t.x, y: t.y - 30, text: '反補！', team: t.team, src: src.id }); if (killerHero) killerHero.denies = (killerHero.denies || 0) + 1; }
      const hs = near(1 - t.team, 1100);
      hs.forEach((h) => this.addExp(h, (denied ? 0.5 : 1) * (t.ranged ? 50 : 40) / Math.max(1, hs.length * 0.6)));
    } else if (t.kind === 'creep' || t.kind === 'boss') {
      if (killerHero) {
        killerHero.gold += t.gold;
        if (killerHero.human) this.dmgEvents.push({ x: t.x, y: t.y - 30, text: `+${t.gold} 金`, gold: 1, team: t.team, src: killerHero.id });
        const hs = near(killerHero.team, 1100);
        hs.forEach((h) => this.addExp(h, t.xp / Math.max(1, hs.length * 0.7)));
        if (t.kind === 'boss') {
          killerHero.stat.boss++;
          this.heroes(killerHero.team).forEach((h) => { h.gold += 250; this.addExp(h, 200); });
          (this.lubu || (this.lubu = [0, 0]))[killerHero.team] = this.t + SG.LUBU_BUFF.t; // 全隊增益（v0.3.8，取代赤兔馬）
          this.say(`${killerHero.name} 擊敗了呂布！${killerHero.team ? '魏軍' : '聯軍'}全軍獲得「${SG.LUBU_BUFF.name}」${SG.LUBU_BUFF.t} 秒`, 'big');
          this.feed.push({ t: this.t, text: `${killerHero.name} 擊敗 呂布`, team: killerHero.team });
        }
      }
    } else if (t.kind === 'hero') {
      this.kills[1 - t.team]++;
      t.deaths++; t.respawn = (4 + t.lv * 2) * this.tune.respawn; t.gold = Math.max(0, t.gold - 30 * t.lv);
      const assists = this.heroes(1 - t.team).filter((h) => h !== killerHero && t.dmgBy[h.id] > this.t - 10);
      // 賞金：被擊殺者連殺越多越值錢；終結連殺另有播報
      const bounty = Math.min(500, Math.max(0, (t.streak || 0) - 1) * 80);
      const gold = 300 + 25 * t.lv + bounty + (this.firstBlood ? 0 : 100);
      const by = killerHero ? killerHero.name : src.kind === 'tower' || src.kind === 'base' ? '城寨' : '小兵';
      if (killerHero) {
        killerHero.kills++; killerHero.gold += gold;
        if (this.rules.solo && this.kills[killerHero.team] + 1 >= 2) this.over = killerHero.team; // 單挑：先兩殺者勝
        killerHero.streak = (killerHero.streak || 0) + 1;
        // 連殺計數用 killChain；multi 是多重箭的支數，兩者不能共用
        killerHero.killChain = killerHero.lastKillT > this.t - 10 ? (killerHero.killChain || 1) + 1 : 1;
        killerHero.lastKillT = this.t;
        killerHero.stat.maxMulti = Math.max(killerHero.stat.maxMulti, killerHero.killChain); killerHero.stat.maxStreak = Math.max(killerHero.stat.maxStreak, killerHero.streak);
        if (!this.firstBlood) killerHero.stat.fb = 1;
        this.vfx.push({ k: 'herokill', x: t.x, y: t.y, by: killerHero.id, tgt: t.id, multi: killerHero.killChain, t: this.t });
        if (killerHero.human) this.dmgEvents.push({ x: t.x, y: t.y - 40, text: `+${gold} 金`, gold: 2, team: t.team, src: killerHero.id });
        const MULTI = { 2: '雙殺', 3: '三殺', 4: '四殺', 5: '五殺！' }, STREAK = { 3: '大殺特殺', 5: '勢不可擋', 7: '萬夫莫敵', 9: '天下無雙' };
        if (MULTI[killerHero.killChain]) this.say(`${killerHero.name} ${MULTI[killerHero.killChain]}`, 'kill', killerHero.team);
        else if (STREAK[killerHero.streak]) this.say(`${killerHero.name} ${STREAK[killerHero.streak]}！`, 'kill', killerHero.team);
      }
      if ((t.streak || 0) >= 3) this.say(`${by} 終結了 ${t.name} 的 ${t.streak} 連殺！賞金 ${bounty} 金`, 'kill', 1 - t.team);
      t.streak = 0; t.killChain = 0;
      const share = Math.round((120 + 10 * t.lv) / Math.max(1, assists.length) * Math.min(assists.length, 2));
      assists.forEach((h) => { h.assists++; h.gold += share; if (h.human) this.dmgEvents.push({ x: h.x, y: h.y - 90, text: `助攻 +${share} 金`, gold: 1, team: h.team, src: h.id }); });
      const hs = near(1 - t.team, 1200);
      hs.forEach((h) => this.addExp(h, (220 + 45 * t.lv) / Math.max(1, hs.length * 0.6)));
      this.feed.push({ t: this.t, text: `${by} 擊殺 ${t.name}`, team: 1 - t.team });
      if (!this.firstBlood) { this.firstBlood = true; this.say(`第一滴血！${by} 擊殺 ${t.name}`, 'kill', 1 - t.team); }
      this.tell(t, `你被 ${by} 擊殺了`, 'bad');
      t.dmgBy = {};
    } else if (t.kind === 'cart') {
      if (killerHero) { killerHero.gold += 150; killerHero.stat.carts++; }
      this.heroes(1 - t.team).forEach((h) => { if (h.alive && gd(h.x, h.y, t.x, t.y) < 1200) { h.gold += 80; this.addExp(h, 80); } });
      this.say(`${t.team ? '魏軍' : '聯軍'}的糧車被劫了！`, 'big');
      this.feed.push({ t: this.t, text: `${killerHero ? killerHero.name : '小兵'} 劫下糧車`, team: 1 - t.team });
    } else if (t.kind === 'tower') {
      if (this.rules.solo) this.over = 1 - t.team; // 單挑：先拿下一座城寨者勝
      // 最後一擊的人拿 320，其餘隊友各 100；每個人頭上都跳出自己拿到多少
      this.heroes(1 - t.team).forEach((h) => {
        const g = h === killerHero ? 320 : 100;
        h.gold += g; this.addExp(h, 100);
        if (h.human) this.dmgEvents.push({ x: h.x, y: h.y - 90, text: `${h === killerHero ? '拆塔' : '拆塔分紅'} +${g} 金`, gold: 1, team: h.team, src: h.id });
      });
      if (killerHero) killerHero.stat.towers++;
      const ln = ({ top: '上路', mid: '中路', bot: '下路' })[t.lane];
      const side = t.team ? '聯軍' : '魏軍';
      this.say(`${t.team ? '魏軍' : '聯軍'}${ln}城寨被摧毀：${killerHero ? `${killerHero.name} +320 金，${side}其餘每人 +100 金` : `${side}每人 +100 金`}`, 'big');
      this.feed.push({ t: this.t, text: killerHero ? `${killerHero.name} 拆下${ln}城寨（+320／隊友 +100）` : `${ln}城寨倒下（每人 +100）`, team: 1 - t.team });
    } else if (t.kind === 'granary') {
      this.heroes(1 - t.team).forEach((h) => { h.gold += 300; this.addExp(h, 100); });
      this.say(`${t.team ? '魏軍' : '聯軍'}糧倉被燒毀：軍餉減半，${t.team ? '聯軍' : '魏軍'}每人獲得 300 金`, 'big');
      this.feed.push({ t: this.t, text: '糧倉被燒毀', team: 1 - t.team });
    } else if (t.kind === 'barracks') {
      this.heroes(1 - t.team).forEach((h) => { h.gold += 120; this.addExp(h, 80); });
      const ln = ({ top: '上路', mid: '中路', bot: '下路' })[t.lane];
      this.say(`${t.team ? '魏軍' : '聯軍'}${ln}兵營被摧毀，該路不再出兵`, 'big');
      this.feed.push({ t: this.t, text: `${ln}兵營倒下`, team: 1 - t.team });
    } else if (t.kind === 'base') {
      this.over = 1 - t.team;
      this.vfx.push({ k: 'basefall', x: t.x, y: t.y, team: t.team, t: this.t });
    }
  }
  addExp(h, x, silent) {
    const lv0 = h.lv;
    h.exp += x * this.tune.exp;
    let up = false;
    while (h.lv < SG.MAX_LV && h.exp >= SG.expToLevel(h.lv + 1)) { h.lv++; up = true; }
    if (up) {
      if (h.manual) h.pts = (h.pts || 0) + (h.lv - lv0); else h.skillLv = SG.skillLevels(h.spec, h.lv).L;
      this.recalc(h);
      if (!silent) { this.tell(h, `升到 ${h.lv} 級` + (h.manual ? '，有技能點可以配' : ''), 'good'); if (h.human) this.vfx.push({ k: 'levelup', id: h.id, t: this.t }); }
    }
  }
  // 回城（B）：原地引導 3 秒後傳回本營溫泉；移動、出手、被控或被敵將／城寨打到就中斷
  startRecall(u) {
    if (!u.alive || u.recall) return;
    if (this.rules.buyDead) { this.tell(u, '大亂鬥不能回城', 'bad'); return; }
    const s = u.st;
    if (s.stun > 0 || s.freeze > 0 || s.knockup > 0 || s.down > 0 || s.fear > 0 || s.charm > 0 || u.grabbedBy || u.thrown) { this.tell(u, '現在不能回城', 'bad'); return; }
    if (atBaseOf(u)) { this.tell(u, '已經在本營了', 'info'); return; }
    if (u.grab) this.release(u);
    const I = u.input; I.moveTo = I.target = I.amove = null;
    u.recall = { t: 3, dur: 3 };
    this.vfx.push({ k: 'recall', id: u.id, x: u.x, y: u.y, dur: 3 });
    this.tell(u, '回城中……（移動或出手會中斷）', 'info');
  }
  cancelRecall(u, why) { if (!u.recall) return; u.recall = null; this.vfx.push({ k: 'recallx', id: u.id, x: u.x, y: u.y }); this.tell(u, why || '回城中斷', 'bad'); }
  recallTick(u, dt) {
    const I = u.input, s = u.st;
    const ordered = I.moveTo || I.target || I.amove || I.skill || I.jump || I.grab || I.attack || I.item != null || Math.abs(I.mx || 0) + Math.abs(I.my || 0) > 0.1;
    if (!u.alive || s.stun > 0 || s.freeze > 0 || s.knockup > 0 || s.down > 0 || s.fear > 0 || s.charm > 0 || u.grabbedBy || u.thrown) { this.cancelRecall(u, '回城被打斷'); return false; }
    if (ordered) { this.cancelRecall(u, '回城取消'); return false; }
    u.recall.t -= dt; u.loop = 'idle';
    if (u.recall.t > 0) return true;
    u.recall = null;
    const b = M.bases[u.team];
    this.vfx.push({ k: 'recalldone', x: u.x, y: u.y, id: u.id });
    u.x = b.x + (u.team ? -120 : 120); u.y = b.y + (SG.rand() - 0.5) * 160;
    this.vfx.push({ k: 'recalldone', x: u.x, y: u.y, arrive: 1, id: u.id });
    this.tell(u, '回到本營溫泉', 'good');
    return true;
  }
  revive(u) {
    const b = M.bases[u.team];
    u.alive = true; u.hp = u.maxHp; u.mp = u.maxMp; u.x = b.x + (u.team ? -120 : 120); u.y = b.y + (SG.rand() - 0.5) * 160;
    u.act = null; u.anim = 'idle'; u.animSeq++; u.st = mkStatus(); u.input = {}; u.grab = null; u.grabbedBy = null; u.thrown = null;
    this.tell(u, '你已復活', 'good');
  }

  // ---------- 商店與道具 ----------
  inShop(u) { return !u.alive || atBaseOf(u) || M.shopAt(u.x, u.y); } // 陣亡（在溫泉等復活）時也能買賣
  // 合成：身上有的零件折抵價格（每件零件只算一次），回傳要用掉的欄位
  // 合成價格：身上有的零件折抵（v0.3.6 多層：直接材料沒有，就往下找它的零件；例如有兩把鐵劍＋護腕，買青釭劍時鐵劍也折抵）
  recipe(u, it) {
    const used = [];
    let price = it.cost;
    const take = (id) => {
      const def = SG.ITEM[id];
      for (const f of (def && def.from) || []) {
        const slot = u.items.findIndex((x, i) => x && x.id === f && !used.includes(i));
        if (slot >= 0) { used.push(slot); price -= u.items[slot].cost; } else take(f);
      }
    };
    take(it.id);
    return { price, used };
  }
  priceOf(u, it) { return this.recipe(u, it).price; }
  canBuy(u, it) {
    if (it.cat === '神器') return '神器不能購買';
    if (it.army) { if (u.alive && !atBaseOf(u)) return '回到本營才能下軍令'; if (u.gold < it.cost) return '金錢不足'; if ((u.wood || 0) < it.wood) return '木頭不足'; return ''; }
    if (!this.inShop(u)) return M.shopHint || '回到本營、神秘商店或長江商船才能購買';
    if (this.rules.buyDead && u.alive && !atBaseOf(u)) return '大亂鬥只有在本營或陣亡時能買裝';
    const { price, used } = this.recipe(u, it);
    if (u.gold < price) return '金錢不足';
    if (!u.items.includes(null) && !used.length && this.stackSlot(u, it) < 0) return '六格已滿';
    if (it.ranged && !u.ranged) return '遠程武將限定';
    return '';
  }
  buy(u, id) {
    const it = SG.ITEM[id], why = this.canBuy(u, it);
    if (why) { this.tell(u, why, 'warn'); return false; }
    if (it.army) { u.gold -= it.cost; u.wood -= it.wood; this.callArmy(u, it); return true; }
    if (!u.iq) u.iq = u.items.map((x) => (x ? 1 : 0));
    const { price, used } = this.recipe(u, it);
    const st = used.length ? -1 : this.stackSlot(u, it);
    if (st >= 0) { u.gold -= price; u.iq[st] = SG.itemQty(u, st) + 1; return true; } // 消耗品疊在同一格
    used.forEach((i) => { u.items[i] = null; u.icd[i] = 0; u.iq[i] = 0; });
    const slot = used.length ? Math.min(...used) : u.items.indexOf(null);
    u.gold -= price; u.items[slot] = it; u.iq[slot] = 1; this.recalc(u);
    if (used.length) this.tell(u, `合成 ${it.name}（${it.from.map((f) => SG.ITEM[f].name).join('＋')}）`, 'info');
    return true;
  }
  // 軍令：部隊從本營出發，沿武將最近待過的那一路推進
  callArmy(u, it) {
    let lane = (u.ai && u.ai.lane !== 'jungle' && u.ai.lane) || u.lane0 || 'mid';
    if (this.units.some((o) => o.kind === 'barracks' && o.team === u.team && o.lane === lane && !o.alive)) lane = 'mid';
    if (!this.lanes.includes(lane)) lane = this.lanes.includes('mid') ? 'mid' : this.lanes[0];
    const path = M.laneFor(lane, u.team), g = 1 + this.wave * 0.035;
    const bl = Math.hypot(path[1][0] - path[0][0], path[1][1] - path[0][1]), bx = (path[1][0] - path[0][0]) / bl, by = (path[1][1] - path[0][1]) / bl;
    const make = (j, archer, o) => {
      const m = this.spawnMinion(u.team, lane, path[0][0] - bx * j * 56, path[0][1] - by * j * 56, archer);
      m.path = path; m.wp = 1; m.called = true;
      Object.assign(m, o); m.hp = m.maxHp;
      return m;
    };
    const ln = ({ top: '上路', mid: '中路', bot: '下路' })[lane];
    if (it.army === 'ram') make(0, false, { siege: 'ram', name: '衝車', maxHp: 1400, atk: 110 * g, armor: 14, ms: 190, r: 30, range: 90, bldMul: 1 });
    else if (it.army === 'catapult') make(0, true, { siege: 'catapult', name: '投石車', maxHp: 520, atk: 70 * g, armor: 2, ms: 190, r: 30, range: 600, bldMul: 2.5, asp: 60 });
    else if (it.army === 'cavalry') for (let j = 0; j < 3; j++) make(j, false, { name: '騎兵', maxHp: 620 * g, atk: 36 * g, armor: 4, ms: 380, elite: true });
    else for (let j = 0; j < 6; j++) make(j, j >= 4, { name: u.team ? '匈奴兵' : '孫吳兵', maxHp: (j >= 4 ? 420 : 600) * g, atk: (j >= 4 ? 34 : 28) * g, armor: 3, elite: true });
    this.say(`${u.name} 下令：${it.name}走${ln}`, 'info', u.team);
    this.feed.push({ t: this.t, text: `${it.name}出發（${ln}）`, team: u.team });
  }
  // 消耗品疊加（v0.5.0）：同一種消耗品一格最多 SG.STACK 個；回傳還放得下的那一格，沒有就 -1
  stackSlot(u, it) {
    if (!it || !it.consumable) return -1;
    if (!u.iq) u.iq = u.items.map((x) => (x ? 1 : 0));
    return u.items.findIndex((x, i) => x && x.id === it.id && SG.itemQty(u, i) < SG.STACK);
  }
  // 用掉（或賣掉）一個：疊著的扣一個，最後一個用完才清掉這一格
  takeOne(u, slot) {
    const q = SG.itemQty(u, slot);
    if (!u.iq) u.iq = u.items.map((x) => (x ? 1 : 0));
    if (q > 1) { u.iq[slot] = q - 1; return; }
    u.items[slot] = null; u.iq[slot] = 0; this.recalc(u);
  }
  // v0.3.0：道具欄換位置（冷卻跟著道具走）；任何地方都能換
  swapItems(u, a, b) {
    a |= 0; b |= 0;
    if (a === b || a < 0 || b < 0 || a > 5 || b > 5 || !u.items || (!u.items[a] && !u.items[b])) return false;
    [u.items[a], u.items[b]] = [u.items[b], u.items[a]];
    if (u.icd) [u.icd[a], u.icd[b]] = [u.icd[b], u.icd[a]];
    if (u.iq) [u.iq[a], u.iq[b]] = [u.iq[b], u.iq[a]];
    this.recalc(u);
    return true;
  }
  sell(u, slot) {
    const it = u.items[slot];
    if (!it || !this.inShop(u)) return false;
    u.gold += SG.sellPrice(it); this.takeOne(u, slot); // 疊著的消耗品一次賣一個
    return true;
  }
  useItem(u, slot) {
    const it = u.items[slot];
    if (!it || u.icd[slot] > 0) return;
    const aim = u.input.aim, dir = aim ? dirTo(u, aim[0], aim[1]) : [u.f, 0];
    switch (it.id) {
      case 'jinchuang': // 效果還在就不能再喝（會重設時間、白白浪費一瓶）
        if (u.st.regen > 0) { this.tell(u, `金創藥效果還在（剩 ${Math.ceil(u.st.regen)} 秒）`, 'warn'); return; }
        u.st.regen = 10; u.st.regenAmt = 30; break;
      case 'xingshen': if (!SG.isNeng(u)) u.mp = Math.min(u.maxMp, u.mp + 150); break;
      case 'chihou': this.units.push(unit({ kind: 'ward', team: u.team, x: u.x, y: u.y, life: 90, r: 10, hp: 1, maxHp: 1 })); break;
      case 'jili': this.zone(u, { x: u.x, y: u.y, r: 90, t: 8, tick: 0.5, dmg: 0, slow: 0.45, ground: true }); break;
      case 'huoyou': { const p = along(u.x, u.y, dir, 200); this.zone(u, { x: p[0], y: p[1], r: 80, t: 4, tick: 0.5, dmg: 40, ground: true, fire: true, pal: 'fire' }); break; }
      case 'qimen': case 'dunjia': { const p = along(u.x, u.y, dir, 400), q = landing(u.x, u.y, p[0], p[1]); this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = q[0]; u.y = q[1]; this.fx({ k: 'puff', x: u.x, y: u.y }); u.icd[slot] = 14; return; }
      case 'jueying': u.st.msUp = 3; u.st.msUpAmt = 0.4; u.icd[slot] = 20; return;
      case 'xuantie': u.st.dr = 3; u.st.drAmt = 0.6; u.icd[slot] = 30; return;
      default: return;
    }
    if (it.consumable) this.takeOne(u, slot);
  }

  // ---------- 控制效果 ----------
  hardCC(t) { const s = t.st; return s.stun > 0 || s.root > 0 || s.knockup > 0 || s.down > 0 || s.freeze > 0 || s.fear > 0 || s.taunt > 0 || s.charm > 0 || s.confuse > 0; }
  applyCC(src, t, cc) {
    if (!cc || !t.alive || t.structure || t.kind === 'cart') return;
    if (this._skShot && this._skShot === (src.owner || src)) cc = SG.scaleCC(cc, SG.SKILLSHOT_BONUS); // 指向技進行中直接套的控制 +10%
    if (t.bf && t.bf.immune) return; // 魔法免疫
    if (t.untargetable) return;
    const s = t.st, own = src.owner || src;
    if (cc.slow) { s.slowAmt = s.slow > 0 ? Math.max(s.slowAmt, cc.slow[0]) : cc.slow[0]; s.slow = Math.max(s.slow, cc.slow[1]); }
    if (cc.knockback && t.kind !== 'boss') { const d = dirTo(src, t.x, t.y); move(t, d[0] * cc.knockback, d[1] * cc.knockback); }
    if (t.kind === 'boss') return; // 首領只吃緩速
    if (cc.silence) s.silence = Math.max(s.silence, cc.silence);
    if (cc.disarm) s.disarm = Math.max(s.disarm, cc.disarm);
    const hard = HARD_CC.filter((k) => cc[k]);
    if (!hard.length) return;
    // 同一目標 3 秒內連續被控，時間依次遞減為 60%、36%…，避免被控到死
    const mul = s.ccRes > 0 ? Math.pow(0.6, s.ccStack) : 1;
    s.ccStack = s.ccRes > 0 ? s.ccStack + 1 : 1; s.ccRes = 3; s.ccBy = own;
    let label = null;
    for (const k of hard) {
      const d = cc[k] * mul;
      if (k === 'stun') { s.stun = Math.max(s.stun, d); label = label || '暈眩'; }
      else if (k === 'root') { s.root = Math.max(s.root, d); label = label || '定身'; }
      else if (k === 'knockup') { s.knockup = Math.max(s.knockup, d); t.anim = 'jump'; t.animSeq++; label = '擊飛'; }
      else if (k === 'knockdown') { s.down = Math.max(s.down, d); t.anim = 'fall'; t.animSeq++; label = '擊倒'; }
      else if (k === 'freeze') { s.freeze = Math.max(s.freeze, d); label = '凍結'; }
      else if (k === 'fear') { s.fear = Math.max(s.fear, d); s.fearDir = sign(t.x - src.x) || 1; label = label || '恐懼'; }
      else if (k === 'taunt') { s.taunt = Math.max(s.taunt, d); s.tauntBy = own; label = '嘲諷'; }
      else if (k === 'charm') { s.charm = Math.max(s.charm, d); s.charmBy = own; label = '魅惑'; }
      else if (k === 'confuse') { s.confuse = Math.max(s.confuse, d); s.cT = 0; label = '迷亂'; }
    }
    if (t.act && t.act.kind !== 'skill') { t.act = null; t.air = false; t.noPx = false; }
    if (t.grab) this.release(t);
    if (label && (own.human || t.human)) this.dmgEvents.push({ x: t.x, y: t.y - 30, text: label, team: t.team, src: own.id, tgt: t.id, cc: 1 });
  }
  onHitProcs(u, t) {
    if (u.px && t.alive) this.xHit(u, t);
    for (const h of H_ONHIT_PRE) h.fn.call(this, u, t);
    if (!u.procs || !u.procs.length || !t.alive) return;
    for (const o of u.procs) {
      if (o.proc && SG.rand() < o.proc) { if (o.procShred) t.st.shred = 4; else this.applyCC(u, t, o.procCC); }
      if (o.burnHit) this.ignite(t, o.burnHit, 2, u);
    }
  }
  later(sec, fn) { const el = this._el, src = this._src; (this.timers || (this.timers = [])).push({ t: sec, fn: el || src != null ? () => { const e0 = this._el, s0 = this._src; this._el = el; this._src = src; fn(); this._el = e0; this._src = s0; } : fn }); }

  // ---------- 地圖機制 ----------
  startWind(sec) {
    if (this.wind.on <= 0) this.say('東風起！火攻傷害 +50%，向西的投射物更快更遠', 'big');
    this.wind.on = Math.max(this.wind.on, sec);
  }
  windTick(dt) {
    const w = this.wind;
    if (w.on > 0) { w.on -= dt; if (w.on <= 0) { w.on = 0; this.say('東風停了', 'info'); } return; }
    w.next -= dt;
    if (w.next <= 0) { w.next = 120; this.startWind(30); }
  }
  sealTick(dt) {
    const s = this.seal;
    if (s.state === 'wait') {
      s.t -= dt;
      if (s.t > 0) return;
      // 隱藏典故「孫堅得璽」（v0.3.8）：只有一方有孫堅 → 時間一到玉璽直接歸孫堅（陣亡中就等他復活）；兩方都有孫堅就照常搶奪
      const sj = this.heroes().filter((h) => h.spec && h.spec.id === 'sunjian');
      if (sj.length && sj.every((h) => h.team === sj[0].team)) {
        const h = sj.find((x) => x.alive);
        if (!h) return;
        Object.assign(s, { state: 'held', holder: h, gt: 0, unit: null, team: -1 });
        h.seal = true; if (h.stat) h.stat.seal++; this.recalc(h);
        this.say('典故「孫堅得璽」：孫堅於洛陽甄官井中得傳國玉璽！', 'big');
        this.feed.push({ t: this.t, text: `${h.name} 得傳國玉璽`, team: h.team });
        return;
      }
      this.sealDrop(s.x, s.y); this.say('傳國玉璽出現在下游沙洲！普攻五下奪璽', 'big');
      return;
    }
    if (s.state === 'ground') return;
    const h = s.holder;
    if (!h.alive) {
      h.seal = false; this.recalc(h);
      // v0.3.6：被武將擊殺 → 玉璽直接歸擊殺者；被小兵、城寨、黃巾賊殺死 → 掉在原地重搶
      const k = h.lastKiller, kh = k && k.kind === 'hero' ? k : null; // 召喚物、小兵、城寨殺的都算非武將
      if (kh && kh.kind === 'hero' && kh.alive && kh.team !== h.team) {
        Object.assign(s, { state: 'held', holder: kh, gt: 0, unit: null, team: -1 });
        kh.seal = true; if (kh.stat) kh.stat.seal++; this.recalc(kh);
        this.say(`${kh.name} 斬殺 ${h.name}，奪得傳國玉璽！`, 'big');
        this.feed.push({ t: this.t, text: `${kh.name} 奪得玉璽`, team: kh.team });
        return;
      }
      const p = M.walkable(h.x, h.y) ? [h.x, h.y] : M.center.slice();
      this.sealDrop(p[0], p[1]);
      this.say('傳國玉璽掉落了！', 'big');
      return;
    }
    s.gt += dt;
    if (s.gt >= 10) { s.gt = 0; this.heroes(h.team).forEach((x) => { x.gold += 15; }); }
  }
  // 玉璽落地：變成一個 5 點血的單位，讓武將點選、普攻
  sealDrop(x, y) {
    const s = this.seal;
    if (s.unit) this.units = this.units.filter((u) => u !== s.unit);
    const u = unit({ kind: 'seal', team: 2, name: '傳國玉璽', x, y, r: 26, hp: 5, maxHp: 5, atk: 0, armor: 0, ms: 0, range: 0, vis: [true, true] });
    this.units.push(u);
    Object.assign(s, { state: 'ground', x, y, holder: null, unit: u, team: -1 });
  }
  // 玉璽被打：只有武將普攻算數，每下 1；換另一隊打就重置成 5；打下最後一下的武將奪璽
  sealHit(src, t, o) {
    const s = this.seal;
    if (src.kind !== 'hero' || !o.basic || s.state !== 'ground' || t !== s.unit) return;
    if (s.team !== src.team) { t.hp = t.maxHp; s.team = src.team; }
    t.hp -= 1;
    this.dmgEvents.push({ x: t.x, y: t.y - 50, v: 1, team: 2, src: src.id, tgt: t.id });
    if (t.hp > 0) return;
    t.alive = false; this.units = this.units.filter((u) => u !== t);
    Object.assign(s, { state: 'held', holder: src, gt: 0, unit: null, team: -1 });
    src.seal = true; if (src.stat) src.stat.seal++; this.recalc(src);
    if (src.input && src.input.target === t) src.input.target = null;
    this.say(`${src.name} 奪得傳國玉璽！`, 'big');
    this.feed.push({ t: this.t, text: `${src.name} 奪得玉璽`, team: src.team });
  }
  cartTick(dt) {
    this.cartT -= dt;
    if (this.cartT > 0) return;
    this.cartT = 90;
    for (let team = 0; team < 2; team++) {
      // 聯軍沿下路往東送到江邊；魏軍是點對稱，沿上路往西
      const path0 = [[760, 4100], [4700, 4100]];
      const path = team ? path0.map(M.mir) : path0;
      this.units.push(unit({ kind: 'cart', team, x: path[0][0], y: path[0][1], path, wp: 1, f: team ? -1 : 1, r: 34, hp: 1600, maxHp: 1600, armor: 10, ms: 95, range: 0, name: '糧車' }));
    }
    this.say('雙方糧車出發（聯軍走下路、魏軍走上路）', 'info');
  }
  cartMove(u, dt) {
    const wp = u.path[u.wp];
    if (gd(u.x, u.y, wp[0], wp[1]) < 20) {
      if (u.wp < u.path.length - 1) u.wp++;
      else {
        u.alive = false; u.deadT = this.t; u.arrived = true;
        this.supply[u.team] = 3;
        this.heroes(u.team).forEach((h) => { h.gold += 80; });
        this.say(`${u.team ? '魏軍' : '聯軍'}糧草送達：接下來三波小兵強化`, 'big');
        this.feed.push({ t: this.t, text: '糧草送達', team: u.team });
        return;
      }
    }
    const s = this.speed(u) * dt, d = dirTo(u, wp[0], wp[1]);
    u.f = sign(d[0]) || u.f;
    move(u, d[0] * s, d[1] * s);
  }

  say(text, kind, team) { this.msgs.push({ t: this.t, text, kind: kind || 'info', team }); }
  // 只給某位真人玩家看的訊息
  tell(u, text, kind) { if (u.human) this.msgs.push({ t: this.t, text, kind: kind || 'info', to: u.id }); }
}
SG.World = World;
SG._sim = { move, landing, unit, mkStatus, clearLine };
